"use client";
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import { Clock8, ChevronLeft, Radius } from "lucide-react";
import ChargesModal from "./Chargesmodal";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Button,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  IconButton,
  Tooltip,
  LinearProgress,
  ClickAwayListener,
  Popover,
  GlobalStyles,
} from "@mui/material";
import moment from "moment-timezone";
import { useSelector, useDispatch } from "react-redux";
import airlinelogo from "../../../assets/images/active-flight-icon.svg";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CategoryIcon from "@mui/icons-material/Category";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { useNavigate, useSearchParams } from "react-router-dom";
import FlightIcon from "@mui/icons-material/Flight";
import AlertDialogBox from "../../common/AlertDialogBox";
import { formatTemperatureRange } from "../../common/BookingDetailUI";
import {
  clearOceanSearchForm,
  clearSearchRateAvailableData,
  searchratestate,
  setsearchratesAvailableData,
  viewBreakUp,
} from "../../../store/SearchRates/SearchRatesSlice";
import { setFilterData, clearFilters, setSurchargeSelection, clearSurchargeSelection } from "../../../store/Newslices/filterSlice";
import BookCargo from "../../common/PaymentSection/BookCargo";
import aeroplan from "../../../assets/icons/aeroplan.png";
import pickup from "../../../assets/icons/package-delivery.png";
import delivery from "../../../assets/icons/delivery-charges.png";
import airfreight from "../../../assets/icons/transportation.png";
import originimg from "../../../assets/icons/origin.png";
import destinationimg from "../../../assets/icons/destination.png";
import editquery from "../../../assets/icons/edit_query.png";
import Bookingintermediatrypage from "../../common/PaymentSection/BookingIntermediatrypage";
import FilterChips from "../../../forms/SearchRates/Filters/Filterchips";
import FilterButton from "../../../forms/SearchRates/Filters/FilterButton";
import FilterForm from "../../../forms/SearchRates/Filters/FilterForm";
import { formatrates } from "../../../functions/Utils";
import { buildPassivePharmaDtl } from "../../../utils/buildRateSearchPayload";
import { isEkRate, getRateKey } from "../../../utils/ekRate";
import { setBookingdata } from "../../../store/BookingIntermediaterypage/airlineairportslice";
import {
  getManualQuoteDetailById,
  setManualQuoteDetail,
} from "../../../store/ManualQuote/ManualQuoteSlice";
import { authuser } from "../../../store/Authentication/AuthSlice"
import {
  updateStoredSearch,
  updatequeryid,
  updatebookingid,
  manualstatus,
} from "../../../store/Newsearchform/Newsearchform";
import { setBookingIdStore } from "../../../store/Newslices/bookingIdSlice";
import { getsinglebookingdata } from "../../../store/BookingHistory/BookingHistorySlice";
import { setPrevBookingAmountStore, clearPrevBookingAmountStore } from "../../../store/Newslices/prevBookingAmountSlice";
import { httpinstance } from "../../../axios/api";
import { ManageSocketContext } from "../../../ManageSocketContext";
import FailureSearchRate from "../../../components/SearchRates/FailureSearchRate";
import VerifyEmailModal from "../../common/VerifyEmailModal";
import { isQueryLimitReached } from "../../../utils/queryLimit";
import { isKybApproved } from "../../../utils/kyb";
import { kybstatus } from "../../../store/User/KycSlice";
// ✅ toast imports removed — KYC messaging handled by ribbon in PageLayout
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

const getFlagUrl = (countryName) => {
  if (!countryName) return null;
  const code = countries.getAlpha2Code(countryName.trim(), "en");
  return code ? `https://flagcdn.com/w40/${code.toLowerCase()}.png` : null;
};

// ─── Skeleton block ──────────────────────────────────────────────
// Exported so the `?queryId=` deep-link bootstrap (NewSearchRatesResult) can
// show the SAME shimmer while it fetches the saved query. That fetch happens
// before this component mounts, so without sharing it the user would see one
// loader hand over to a different-looking one mid-load.
export const SkeletonCards = ({ count = 4 }) => (
  <>
    {Array.from({ length: count }).map((_, index) => (
      <div className="mt-5" key={`skeleton-${index}`}>
        <div className="listingSkelton">
          <div className="Klistingbooked Klistingbookpadding">
            <div className="Kairlogo ">
              <figure className="Kline w-[100px] h-[20px] mb-1 "></figure>
              <p className="Kline w-[100px] h-[20px] mb-1"></p>
            </div>
            <div className="Kairldesination text-center">
              <figure className="Kline w-[35px] h-[35px] mb-1 rounded-full block m-auto"></figure>
              <p className="Kline w-[100px] h-[20px] mb-1"></p>
            </div>
            <div className="Ktimemain gap-x-5">
              <div className="Ktimestart ">
                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                <p className="Kline w-[100px] h-[20px]"></p>
              </div>
              <div className="KtimeTotal ">
                <p className="Kline w-[100px] h-[20px] mb-1"></p>
              </div>
              <div className="Ktimestart ">
                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                <p className="Kline w-[100px] h-[20px]"></p>
              </div>
            </div>
            <div className="vewmorebox ">
              <p className="Kline w-[100px] h-[16px] mb-1"></p>
              <p className="Kline w-[100px] h-[20px]"></p>
            </div>
            <div className="vewmorebox ">
              <p className="Kline w-[100px] h-[30px] mb-1"></p>
            </div>
          </div>
          <div className="KlistingBottom Klistingbookpadding">
            <div className="Kservicebttom flex items-center">
              <figure className="Kline2 w-[24px] h-[24px] mb-1 rounded-full block m-auto mr-2"></figure>
              <p className="Kline2 w-[80px] h-[10px] mb-1"></p>
            </div>
            <div className="servicebttomToggle">
              <p className="Kline2 w-[20px] h-[10px] mb-1"></p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </>
);

const SkeletonTabs = () => (
  <div className="Tabtopskeltibg flex">
    {Array.from({ length: 3 }).map((_, index) => (
      <div key={index} className="Stabbook text-center mr-3">
        <p className="Kline w-[80px] h-[20px] mb-1 block m-auto"></p>
        <p className="Kline w-[100px] h-[20px] mb-1"></p>
      </div>
    ))}
  </div>
);

// Emirates (EK) streams each product on its own socket event: EK_<code>_res.
// Keep in sync with EK_PRODUCT_CODES in the backend's Airlinesocketservice.js.
// The backend only relays products that came back with rates, and applies the
// markup there — so whatever arrives here is already priced for the customer.
const EK_PRODUCT_CODES = [
  "AOG",
  "AXA",
  "AXD",
  "AXS",
  "GCR",
  "PXD",
  "PXS",
  "VAL",
  "VUN",
];
const EK_RESULT_EVENTS = EK_PRODUCT_CODES.map((code) => `EK_${code}_res`);

// ─── Normalize airline response into date-grouped array ──────────
function normalizeAirlineResponse(airlineResponse) {
  if (!airlineResponse) return [];
  let rawItems = [];
  if (
    !Array.isArray(airlineResponse) &&
    Array.isArray(airlineResponse.availabilityResponseSOs)
  ) {
    rawItems = airlineResponse.availabilityResponseSOs;
  } else if (Array.isArray(airlineResponse)) {
    const isPreGrouped = airlineResponse.some((item) => item?.departureDate);
    if (isPreGrouped) {
      return airlineResponse.map((item) => ({
        ...item,
        departureDate:
          item.departureDate && item.departureDate !== "unknown"
            ? moment(item.departureDate).format("YYYY-MM-DD")
            : item.departureDate,
      }));
    }
    rawItems = airlineResponse;
  } else {
    return [];
  }
  const grouped = {};
  for (const so of rawItems) {
    const rawDepDate =
      so?.flightItineraries?.[0]?.scheduledDepartureDate || "unknown";
    const depDate =
      rawDepDate !== "unknown"
        ? moment(rawDepDate).format("YYYY-MM-DD")
        : "unknown";
    if (!grouped[depDate]) {
      grouped[depDate] = { departureDate: depDate, availabilityResponseSOs: [] };
    }
    grouped[depDate].availabilityResponseSOs.push(so);
  }
  return Object.values(grouped);
}

// Dedup key for a single SO. Live rates dedup by requestRefId (the same SO is
// re-emitted across socket batches). Manual-quote rows (MQ_res / Mannualdummydata)
// can legitimately share a requestRefId — e.g. seeded/dummy rows — so key them by
// their full content instead, deduping only exact duplicates and never dropping
// two genuinely different manual rows that happen to share an id. EK rows share
// a requestRefId across products, so they dedup by rateQuotationID instead.
function soDedupKey(so) {
  if (so?.ratesFrom === "manualQoute") return JSON.stringify(so);
  return getRateKey(so) ?? JSON.stringify(so);
}

// For manual quotes the carrier code may come as a separate field. Prepend it to
// the flight number only when the number doesn't already begin with it (compared
// case-insensitively), so "JP" + "jp123" stays "jp123" instead of "JP jp123".
function formatFlightNo(ratesFrom, carrierCode, carrierNumber) {
  if (ratesFrom !== "manualQoute" || !carrierCode) return carrierNumber;
  const code = String(carrierCode).toLowerCase();
  const number = String(carrierNumber ?? "").toLowerCase();
  return number.startsWith(code)
    ? carrierNumber
    : `${carrierCode} ${carrierNumber}`;
}

function mergeDataBasedOnDate(searchResArray = []) {
  const groupedByDate = {};
  for (const response of searchResArray) {
    const rawDate = response?.departureDate;
    if (!rawDate) continue;
    const date =
      rawDate !== "unknown" ? moment(rawDate).format("YYYY-MM-DD") : rawDate;
    if (!groupedByDate[date]) {
      groupedByDate[date] = {
        ...response,
        departureDate: date,
        availabilityResponseSOs: [...(response?.availabilityResponseSOs || [])],
        _seenIds: new Set(
          (response?.availabilityResponseSOs || []).map(soDedupKey),
        ),
      };
    } else {
      const existing = groupedByDate[date];
      for (const item of response?.availabilityResponseSOs || []) {
        const key = soDedupKey(item);
        if (!existing._seenIds.has(key)) {
          existing._seenIds.add(key);
          existing.availabilityResponseSOs.push(item);
        }
      }
    }
  }
  const result = Object.values(groupedByDate);
  for (const item of result) delete item._seenIds;
  return result.sort(
    (a, b) => new Date(a.departureDate) - new Date(b.departureDate),
  );
}

function findMinRate(dateGroupedArray) {
  if (!dateGroupedArray) return [];
  return dateGroupedArray.map((item) => {
    const list = item?.availabilityResponseSOs || [];
    let min = Infinity;
    for (let i = 0; i < list.length; i++) {
      const rate = Number(list[i]?.rateDetails?.totalAmount);
      if (rate < min) min = rate;
    }
    return { ...item, minRate: min === Infinity ? 0 : min, rates_count: list.length };
  });
}

function getDisplayTotals(option, sel) {
  const rates_f = option?.ratesFrom === "storedrate";
  const bd = option?.rateDetails?.chargesBreakDown || [];
  const getAmt = (c) => c?.Totalamount ?? c?.totalAmount ?? 0;
  let total, perKg;
  if (rates_f) {
    total = bd.reduce((s, c) => s + (Number(c?.chargeAmount) || 0), 0);
    perKg = option?.rateDetails?.ratePerkilo;
    return { total, perKg };
  }
  if (bd.length > 0) {
    const mainC = bd.find((c) => c?.category === "Main");
    const fuelSecC = bd.filter(
      (c) => c?.category === "Fuel" || c?.category === "Security"
    );
    const otherC = bd.filter((c) => c?.category === "Other taxes");
    const screenC = bd.filter((c) => c?.category === "Screening");
    total = getAmt(mainC) + fuelSecC.reduce((s, c) => s + getAmt(c), 0);
    perKg =
      (mainC?.ratePerkilo ?? 0) +
      fuelSecC.reduce((s, c) => s + (c?.ratePerkilo ?? 0), 0);
    if (sel?.otherFees) {
      total += otherC.reduce((s, c) => s + getAmt(c), 0);
      perKg += otherC.reduce((s, c) => s + (c?.ratePerkilo ?? 0), 0);
    }
    if (sel?.screening) {
      total += screenC.reduce((s, c) => s + getAmt(c), 0);
      perKg += screenC.reduce((s, c) => s + (c?.ratePerkilo ?? 0), 0);
    }
  } else {
    total = option?.rateDetails?.totalAmount;
    perKg = option?.rateDetails?.ratePerkilo;
  }
  return { total, perKg };
}

function getDisplayRatePerKg(option) {
  const ratesFrom =
    option?.flightItineraries?.[0]?.rates_from || option?.ratesFrom;
  if (ratesFrom !== "FS" && ratesFrom !== "manualQoute") {
    return option?.rateDetails?.ratePerkilo;
  }
  const mainCharge = (option?.rateDetails?.chargesBreakDown || []).find(
    (c) => c?.category === "Main"
  );
  return mainCharge?.ratePerkilo ?? option?.rateDetails?.ratePerkilo;
}

// ─── Reusable query-header band ──────────────────────────────────
const QueryHeaderBand = ({
  airportcode,
  originAirport,
  originPort,
  destinationAirport,
  destinationPort,
  goodsDetails,
  productDetails,
  commodityGroup,
  commodityDescription,
  packagingDetails,
  temperatureRange,
  navigate,
  handleback,
  roleType,
  image,
  nodeData,
  isManualQuoted,
  convertMinutesToDaysHoursMinutes,
  isFailure = false,
  surchargeSelection,
  toggleOtherFees,
  toggleScreening,
}) => {
  const [surchargeAnchorEl, setSurchargeAnchorEl] = useState(null);
  const showSurchargeDropdown = Boolean(surchargeAnchorEl);
  const originCountry = (originAirport || originPort)?.origincountryName;
  const destCountry =
    (destinationAirport || destinationPort)?.destinationcountryName;
  const originFlagUrl =
    (originAirport || originPort)?.originLogoUrl || getFlagUrl(originCountry);
  const destFlagUrl =
    (destinationAirport || destinationPort)?.destinationLogoUrl ||
    getFlagUrl(destCountry);

  const vol = packagingDetails?.shipmentTotal?.totalvolume;
  const gw = packagingDetails?.shipmentTotal?.totalweight;
  const cwRaw = packagingDetails?.shipmentTotal?.chargeableweight;
  const wunit = packagingDetails?.shipmentTotal?.weightunit || "KG";

  const volUnit = packagingDetails?.shipmentTotal?.unit || "CBM";
  const storedVW = packagingDetails?.shipmentTotal?.totalvolweight;
  const vwVal =
    storedVW != null && parseFloat(storedVW) > 0
      ? parseFloat(storedVW)
      : vol
        ? volUnit === "CFT"
          ? parseFloat(vol) * 0.0283168 * 166.67
          : parseFloat(vol) * 166.67
        : null;

  const cwVal =
    cwRaw || (gw && vwVal ? Math.max(Number(gw), vwVal) : null);

  const chips = [
    {
      icon: <CalendarTodayIcon sx={{ fontSize: 12, color: "#EFA603" }} />,
      label: goodsDetails?.cargoreadydate,
    },
    {
      icon: <CategoryIcon sx={{ fontSize: 12, color: "#EFA603" }} />,
      // `productDetails` only exists when the search came from the air search
      // form. A "Quote Available" query opened straight into these results
      // (buildAirSearchPayload — no form in between) carries the commodity on
      // the query document instead, resolved into `commodityDescription` by the
      // parent, so fall back to that rather than dropping the chip.
      label: productDetails?.natureOfGoods || commodityDescription || null,
    },
    {
      // Temperature-controlled (Perishables) searches only — formatTemperatureRange
      // returns '' for everything else, so the .filter below drops the chip
      // entirely rather than showing an empty one.
      icon: <AcUnitIcon sx={{ fontSize: 12, color: "#0EA5E9" }} />,
      label: formatTemperatureRange(temperatureRange) || null,
    },
    {
      label: packagingDetails?.shipmentTotal?.totalunits
        ? `${packagingDetails?.shipmentTotal?.totalunits} Units`
        : null,
    },
    {
      label: vol
        ? `${Number(vol).toFixed(2)} ${packagingDetails?.shipmentTotal?.unit || "CBM"
        }`
        : null,
    },
    { label: gw ? `G.W ${Number(gw).toFixed(2)} ${wunit}` : null },
    {
      label:
        vwVal != null ? `V.W ${vwVal.toFixed(2)} ${wunit}` : null,
    },
    {
      label:
        cwVal != null
          ? `C.W ${Math.ceil(Number(cwVal))} ${wunit}`
          : null,
    },
  ].filter((c) => c.label);

  return (
    <Paper
      className="airpadding0"
      sx={{
        mb: 2,
        backgroundColor: "#fff9eb",
        borderRadius: 3,
        border: "1.5px solid #F5D98A",
        boxShadow: "0 1px 4px rgba(239,166,3,0.12)",
        padding: 0,
        overflow: "visible",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          width: "100%",
          borderRadius: "inherit",
          overflow: "hidden",
        }}
      >
        {/* ── Back / Edit Query button ── */}
        <div style={{ flexShrink: 0 }}>
          <Box
            className="edit-query_paragraph"
            sx={{
              backgroundColor: "#fff9eb",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                right: 0,
                top: "10%",
                height: "80%",
                width: "2px",
                background:
                  "linear-gradient(to bottom, transparent, #F5C842 30%, #F5C842 70%, transparent)",
                borderRadius: "2px",
              },
            }}
          >
            {roleType !== undefined && roleType ? (
              <Typography sx={{ fontSize: "35px", margin: "8px" }}>
                <div
                  onClick={() => navigate("/queries")}
                  className="relative backimgg circleripp pulse bg-[#fff9eb] text-center flex items-center justify-center"
                >
                  {image}
                  <ChevronLeft className="w-[35px] h-[40px] inline-block" />
                </div>
              </Typography>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                  padding: "10px 18px",
                  "&:hover .back-icon-box": { backgroundColor: "#fff3d4" },
                }}
                onClick={
                  isManualQuoted
                    ? () => navigate("/queries")
                    : handleback
                }
              >
                <Box
                  className="back-icon-box"
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "10px",
                    border: "1.5px solid #EFA603",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background-color 0.2s",
                    boxShadow: "0 1px 4px rgba(239,166,3,0.18)",
                  }}
                >
                  <ArrowBackIcon sx={{ color: "#EFA603", fontSize: 16 }} />
                </Box>
                {!isManualQuoted && (
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#999",
                      whiteSpace: "nowrap",
                      fontWeight: 500,
                      letterSpacing: "0.3px",
                    }}
                  >
                    Edit Query
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </div>

        {/* ── Origin → Destination + chips ── */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "4px",
              py: "8px",
              px: "10px",
              flexWrap: "nowrap",
            }}
          >
            {/* Origin with flag */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                minWidth: "fit-content",
              }}
            >
              {originFlagUrl && (
                <Box
                  component="img"
                  src={originFlagUrl}
                  alt={originCountry}
                  sx={{
                    width: 48,
                    height: 30,
                    objectFit: "cover",
                    borderRadius: "2px",
                    mb: "6px",
                    boxShadow: "0 1px 3px rgba(118, 78, 78, 0.12)",
                  }}
                />
              )}
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 800,
                  color: "#111",
                  lineHeight: 1,
                  letterSpacing: "-0.5px",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                {airportcode?.origincode}
              </Typography>
              <Typography
                sx={{
                  mt: "4px",
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "#8c8c8c",
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  lineHeight: 1,
                }}
              >
                {originCountry}
              </Typography>
            </Box>

            {/* Route: origin ---- plane ---- destination */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                mx: 1,
              }}
            >
              {/* connector line before the plane — exactly 5 dashes */}
              <Box
                sx={{
                  width: 32,
                  height: 2,
                  backgroundImage:
                    "repeating-linear-gradient(to right, #FFC107 0 4px, transparent 4px 7px)",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <Box
                sx={{
                  mx: 1,
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  border: "1.5px solid #FFC107",
                  backgroundColor: "#fff9eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 1px 4px rgba(255,193,7,0.18)",
                }}
              >
                <FlightIcon
                  sx={{
                    color: "#EFA603",
                    fontSize: 20,
                    transform: "rotate(90deg)",
                  }}
                />
              </Box>
              {/* connector line after the plane — exactly 5 dashes */}
              <Box
                sx={{
                  width: 32,
                  height: 2,
                  backgroundImage:
                    "repeating-linear-gradient(to right, #FFC107 0 4px, transparent 4px 7px)",
                  backgroundRepeat: "no-repeat",
                }}
              />
            </Box>

            {/* Destination with flag */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: 58,
              }}
            >
              {destFlagUrl && (
                <Box
                  component="img"
                  src={destFlagUrl}
                  alt={destCountry}
                  sx={{
                    width: 48,
                    height: 30,
                    objectFit: "cover",
                    borderRadius: "2px",
                    mb: "6px",
                    boxShadow: "0 1px 3px rgba(118, 78, 78, 0.12)",
                  }}
                />
              )}
              <Typography
                sx={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#1a1a1a",
                  lineHeight: 1,
                }}
              >
                {airportcode?.destinationcode}
              </Typography>
              <Typography
                sx={{
                  fontSize: 10,
                  color: "#888",
                  mt: "3px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {destCountry}
              </Typography>
            </Box>

            {/* Vertical divider */}
            <Box
              sx={{
                width: "1.5px",
                height: 38,
                background:
                  "linear-gradient(to bottom, transparent, #F5C842 20%, #F5C842 80%, transparent)",
                mx: 2,
                flexShrink: 0,
                alignSelf: "center",
              }}
            />

            {/* Info chips */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              {chips.map((chip, i) => (
                <Box
                  key={i}
                  sx={{
                    padding: "4px 10px",
                    borderRadius: "20px",
                    border: "1px solid #e8e8e8",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    flexShrink: 0,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                  }}
                >
                  {chip.icon && chip.icon}
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#555",
                      fontWeight: 400,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {chip.label}
                  </Typography>
                </Box>
              ))}

              {/* Surcharges toggle */}
              {toggleOtherFees &&
                (() => {
                  const selectedCount =
                    1 +
                    (surchargeSelection?.otherFees ? 1 : 0) +
                    (surchargeSelection?.screening ? 1 : 0);
                  return (
                    <>
                      <Box
                        onClick={(e) =>
                          setSurchargeAnchorEl(
                            surchargeAnchorEl ? null : e.currentTarget
                          )
                        }
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "4px 12px 4px 8px",
                          borderRadius: "20px",
                          border: "1.5px solid #EFA603",
                          backgroundColor: "#fff9eb",
                          cursor: "pointer",
                          userSelect: "none",
                          flexShrink: 0,
                          boxShadow: "0 1px 3px rgba(239,166,3,0.18)",
                          "&:hover": { backgroundColor: "#fff3d4" },
                        }}
                      >
                        {selectedCount > 0 && (
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              borderRadius: "50%",
                              backgroundColor: "#EFA603",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "10px",
                                fontWeight: 700,
                                color: "#fff",
                                lineHeight: 1,
                              }}
                            >
                              {selectedCount}
                            </Typography>
                          </Box>
                        )}
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#856404",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Surcharges
                        </Typography>
                        {showSurchargeDropdown ? (
                          <KeyboardArrowUp
                            sx={{ fontSize: 14, color: "#EFA603" }}
                          />
                        ) : (
                          <KeyboardArrowDown
                            sx={{ fontSize: 14, color: "#EFA603" }}
                          />
                        )}
                      </Box>

                      <Popover
                        open={showSurchargeDropdown}
                        anchorEl={surchargeAnchorEl}
                        onClose={() => setSurchargeAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                        disableScrollLock
                        sx={{ mt: "8px", zIndex: 1400 }}
                        PaperProps={{
                          sx: {
                            borderRadius: "12px",
                            border: "1px solid #e8d98a",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                            padding: "14px 16px",
                            minWidth: 220,
                            overflow: "visible",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "10px",
                            fontWeight: 700,
                            color: "#aaa",
                            letterSpacing: "1px",
                            mb: "12px",
                            textTransform: "uppercase",
                          }}
                        >
                          Include Surcharges
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mb: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Box
                              sx={{
                                width: 18,
                                height: 18,
                                borderRadius: "4px",
                                backgroundColor: "#EFA603",
                                border: "2px solid #EFA603",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Typography>
                            </Box>
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "#222",
                              }}
                            >
                              Fuel & Security
                            </Typography>
                          </Box>
                          <LockIcon sx={{ fontSize: 15, color: "#bbb" }} />
                        </Box>

                        <Box
                          onClick={toggleOtherFees}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            mb: "10px",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 },
                          }}
                        >
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              borderRadius: "4px",
                              backgroundColor: surchargeSelection?.otherFees
                                ? "#EFA603"
                                : "#fff",
                              border: surchargeSelection?.otherFees
                                ? "2px solid #EFA603"
                                : "2px solid #ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {surchargeSelection?.otherFees && (
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Typography>
                            )}
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: surchargeSelection?.otherFees
                                ? 700
                                : 400,
                              color: surchargeSelection?.otherFees
                                ? "#222"
                                : "#888",
                            }}
                          >
                            Other Fees
                          </Typography>
                        </Box>

                        <Box
                          onClick={toggleScreening}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 },
                          }}
                        >
                          <Box
                            sx={{
                              width: 18,
                              height: 18,
                              borderRadius: "4px",
                              backgroundColor: surchargeSelection?.screening
                                ? "#EFA603"
                                : "#fff",
                              border: surchargeSelection?.screening
                                ? "2px solid #EFA603"
                                : "2px solid #ccc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            {surchargeSelection?.screening && (
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Typography>
                            )}
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: surchargeSelection?.screening ? 700 : 400,
                              color: surchargeSelection?.screening
                                ? "#222"
                                : "#888",
                            }}
                          >
                            Screening
                          </Typography>
                        </Box>
                      </Popover>
                    </>
                  );
                })()}
            </Box>
          </Box>
        </div>

        {/* ── Clock Section (manual quotation) ── */}
        {nodeData?.isExpired !== undefined && (
          <div className="2xl:col-span-2 xl:col-span-2 lg:col-span-2 md:col-span-2 col-span-12">
            <div className="text-center h-full flex items-center justify-center px-3">
              <div
                className="text-center text-sm"
                style={{ color: nodeData?.isExpired ? "red" : "blue" }}
              >
                <i>
                  <Clock8 className="inline-block" />
                </i>
                <div className="linedecrease leading-[14px] mt-1">
                  <h4 className="font-bold">
                    {nodeData?.isExpired
                      ? "Quote Expired"
                      : "Quote expiring in"}
                  </h4>
                  {!nodeData?.isExpired &&
                    convertMinutesToDaysHoursMinutes(
                      nodeData?.minutesUntilExpiry
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Paper>
  );
};

let _cpCloseTimer = null;

const ChargeBreakdownContent = ({ breakdown, surchargeSelection }) => {
  const getA = (c) => c?.Totalamount ?? c?.totalAmount ?? 0;
  const fmtAmt = (val) =>
    `₹${Number(val).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  const fmtKg = (val) =>
    `@ ${Number(val ?? 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}/kg`;

  const bd = Array.isArray(breakdown) ? breakdown : [];

  // Non-FS rates (QR / TK / LH / offline / stored) use a flat
  // { chargeType, chargeCode, chargeDescription, chargeAmount } shape instead of
  // the FS category shape — render that variant here.
  const isCategoryShape = bd.some((c) => c?.category);
  const isFlatShape =
    !isCategoryShape &&
    bd.some((c) => c?.chargeType != null || c?.chargeAmount != null);
  if (isFlatShape) {
    const num = (v) => Number(v) || 0;
    const isFreight = (c) =>
      !!(
        c?.chargeType?.toLowerCase?.()?.includes?.("freight") ||
        c?.chargeCode?.toLowerCase?.() === "frt" ||
        c?.chargeType?.toLowerCase?.() === "basic freight"
      );
    const flatItems = bd.filter((c) => c?.chargeAmount != null);
    const freightItems = flatItems.filter(isFreight);
    const surchargeItems = flatItems.filter((c) => !isFreight(c));
    const freightTotal = freightItems.reduce(
      (s, c) => s + num(c?.chargeAmount),
      0
    );
    const surchargeTotal = surchargeItems.reduce(
      (s, c) => s + num(c?.chargeAmount),
      0
    );
    const grandTotal = flatItems.reduce((s, c) => s + num(c?.chargeAmount), 0);
    return (
      <Box sx={{ minWidth: 300, maxWidth: 380 }}>
        <Box
          sx={{
            backgroundColor: "#EFA603",
            px: 2,
            py: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}
          >
            Charge Breakdown
          </Typography>
          <Typography
            sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}
          >
            {fmtAmt(grandTotal)}
          </Typography>
        </Box>

        <Box sx={{ p: 2, backgroundColor: "#fff" }}>
          {freightItems.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1.5px solid #1976D2",
                borderRadius: "8px",
                backgroundColor: "#E3F2FD",
                px: 1.5,
                py: 1,
                mb: 2,
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: 14, color: "#1976D2" }}
              >
                Freight Charges
              </Typography>
              <Typography
                sx={{ fontWeight: 700, fontSize: 14, color: "#1976D2" }}
              >
                {fmtAmt(freightTotal)}
              </Typography>
            </Box>
          )}

          {surchargeItems.length > 0 && (
            <>
              <Typography
                sx={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#888",
                  letterSpacing: "0.8px",
                  textTransform: "uppercase",
                  mb: 0.5,
                }}
              >
                Surcharges
              </Typography>
              <Box
                sx={{
                  border: "1.5px solid #EFA603",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 1.5,
                    py: 1,
                    backgroundColor: "#FFF8E1",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 700, fontSize: 14, color: "#B26A00" }}
                  >
                    Total Surcharges
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 700, fontSize: 14, color: "#B26A00" }}
                  >
                    {fmtAmt(surchargeTotal)}
                  </Typography>
                </Box>
                <Box sx={{ px: 1.5, pb: 1 }}>
                  {surchargeItems.map((sc, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 1,
                        pb: 1,
                        borderBottom:
                          i < surchargeItems.length - 1
                            ? "1px solid #F0F0F0"
                            : "none",
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: "#555" }}>
                        {sc?.chargeDescription || sc?.chargeType || "Surcharge"}
                      </Typography>
                      <Typography
                        sx={{ fontSize: 12, color: "#333", fontWeight: 500 }}
                      >
                        {fmtAmt(num(sc?.chargeAmount))}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Box>
    );
  }

  const pMain = bd.find((c) => c?.category === "Main");
  const pFuel = bd.filter(
    (c) => c?.category === "Fuel" || c?.category === "Security"
  );
  const pOther = bd.filter((c) => c?.category === "Other taxes");
  const pScreen = bd.filter((c) => c?.category === "Screening");
  const hasExtras = pOther.length > 0 || pScreen.length > 0;

  // Everything under the "Other taxes" category is shown in a single "Other Fees"
  // section — the charges are NOT split into separate boxes by chargeType (e.g.
  // "Freight Charges"), since they all belong to the same category.
  const pOtherGroups =
    pOther.length > 0 ? [{ type: "Other Fees", items: pOther }] : [];

  const dynamicTotal =
    getA(pMain) +
    pFuel.reduce((s, c) => s + getA(c), 0) +
    (surchargeSelection?.otherFees
      ? pOther.reduce((s, c) => s + getA(c), 0)
      : 0) +
    (surchargeSelection?.screening
      ? pScreen.reduce((s, c) => s + getA(c), 0)
      : 0);

  return (
    <Box sx={{ minWidth: 320, maxWidth: 400 }}>
      <Box
        sx={{
          backgroundColor: "#EFA603",
          px: 2,
          py: 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}>
          Charge Breakdown
        </Typography>
        <Typography sx={{ fontWeight: 700, color: "#fff", fontSize: 15 }}>
          {fmtAmt(dynamicTotal)}
        </Typography>
      </Box>

      <Box
        sx={{
          p: 2,
          backgroundColor: "#fff",
          // Scroll the breakdown when it's taller than the viewport (e.g. many
          // Screening / Other Fees line items) instead of overflowing off-screen.
          maxHeight: "70vh",
          overflowY: "auto",
        }}
      >
        {pMain && (
          <Box
            sx={{
              border: "1.5px solid #1976D2",
              borderRadius: "8px",
              overflow: "hidden",
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 1.5,
                py: 1,
                backgroundColor: "#E3F2FD",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    backgroundColor: "#EFA603",
                    borderRadius: "4px",
                    px: "6px",
                    py: "1px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "10px", color: "#fff", fontWeight: 700 }}
                  >
                    Required
                  </Typography>
                </Box>
                <Typography
                  sx={{ fontWeight: 700, fontSize: 14, color: "#1976D2" }}
                >
                  Air Freight
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, fontSize: 14, color: "#1976D2" }}
              >
                {fmtAmt(getA(pMain))}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                px: 1.5,
                pb: 1.5,
                pt: 1.2,
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 12, color: "#555" }}>
                  {pMain?.name}
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#888" }}>
                  {fmtKg(pMain?.ratePerkilo)}
                </Typography>
              </Box>
              <Typography
                sx={{ fontSize: 12, color: "#1976D2", fontWeight: 500 }}
              >
                {fmtAmt(getA(pMain))}
              </Typography>
            </Box>
          </Box>
        )}

        {pFuel.length > 0 && (
          <>
            <Typography
              sx={{
                fontSize: 10,
                fontWeight: 700,
                color: "#888",
                letterSpacing: "0.8px",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
              Surcharges
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1.5 }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  border: "2px solid #4CAF50",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 10,
                    color: "#4CAF50",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  ✓
                </Typography>
              </Box>
              <Typography
                sx={{ fontSize: 12, color: "#4CAF50", fontWeight: 500 }}
              >
                Included
              </Typography>
              <Typography sx={{ fontSize: 11, color: "#888" }}>
                (your surcharge selection)
              </Typography>
            </Box>
          </>
        )}

        {pFuel.length > 0 && (
          <Box
            sx={{
              border: "1.5px solid #4CAF50",
              borderRadius: "8px",
              overflow: "hidden",
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 1.5,
                py: 1,
                backgroundColor: "#E8F5E9",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    backgroundColor: "#EFA603",
                    borderRadius: "4px",
                    px: "6px",
                    py: "1px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "10px", color: "#fff", fontWeight: 700 }}
                  >
                    Required
                  </Typography>
                </Box>
                <Typography
                  sx={{ fontWeight: 700, fontSize: 14, color: "#2E7D32" }}
                >
                  Fuel & Security
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, fontSize: 14, color: "#2E7D32" }}
              >
                {fmtAmt(pFuel.reduce((s, c) => s + getA(c), 0))}
              </Typography>
            </Box>
            <Box sx={{ px: 1.5, pb: 1 }}>
              {pFuel.map((fc, fi) => (
                <Box
                  key={fi}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 1,
                    pb: 1,
                    borderBottom:
                      fi < pFuel.length - 1 ? "1px solid #C8E6C9" : "none",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 12, color: "#555" }}>
                      {fc?.name}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#888" }}>
                      {fmtKg(fc?.ratePerkilo)}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{ fontSize: 12, color: "#2E7D32", fontWeight: 500 }}
                  >
                    {fmtAmt(getA(fc))}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {hasExtras && (() => {
          const allExtrasIncluded =
            (pOther.length === 0 || surchargeSelection?.otherFees) &&
            (pScreen.length === 0 || surchargeSelection?.screening);
          return (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  border: `1.5px solid ${allExtrasIncluded ? "#4CAF50" : "#EFA603"}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 11,
                    color: allExtrasIncluded ? "#4CAF50" : "#EFA603",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  {allExtrasIncluded ? "✓" : "+"}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  color: allExtrasIncluded ? "#4CAF50" : "#EFA603",
                  fontWeight: 600,
                }}
              >
                Extra charges
              </Typography>
              <Typography sx={{ fontSize: 11, color: "#888" }}>
                {allExtrasIncluded ? "(Included)" : "(to be applied at check-out)"}
              </Typography>
            </Box>

            {pOther.length > 0 &&
              pOtherGroups.map((group, gi) => (
              <Box
                key={group.type || gi}
                sx={{
                  border: surchargeSelection?.otherFees
                    ? "1.5px solid #4CAF50"
                    : "1.5px solid #E0E0E0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1.5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 1.5,
                    py: 1,
                    backgroundColor: surchargeSelection?.otherFees
                      ? "#E8F5E9"
                      : "transparent",
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: surchargeSelection?.otherFees
                          ? "#2E7D32"
                          : "#333",
                      }}
                    >
                      {group.type}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 14,
                      color: surchargeSelection?.otherFees
                        ? "#2E7D32"
                        : "#888",
                    }}
                  >
                    {fmtAmt(group.items.reduce((s, c) => s + getA(c), 0))}
                  </Typography>
                </Box>
                <Box sx={{ px: 1.5, pb: 1 }}>
                  {group.items.map((oc, oi) => (
                    <Box
                      key={oi}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 1,
                        pb: 1,
                        borderBottom:
                          oi < group.items.length - 1
                            ? `1px solid ${surchargeSelection?.otherFees
                              ? "#C8E6C9"
                              : "#F0F0F0"
                            }`
                            : "none",
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: 12, color: "#555" }}>
                          {oc?.name}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888" }}>
                          {fmtKg(oc?.ratePerkilo)}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 500,
                          color: surchargeSelection?.otherFees
                            ? "#2E7D32"
                            : "#333",
                        }}
                      >
                        {fmtAmt(getA(oc))}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}

            {pScreen.length > 0 && (
              <Box
                sx={{
                  border: surchargeSelection?.screening
                    ? "1.5px solid #4CAF50"
                    : "1.5px solid #E0E0E0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  mb: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 1.5,
                    py: 1,
                    backgroundColor: surchargeSelection?.screening
                      ? "#E8F5E9"
                      : "transparent",
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: surchargeSelection?.screening
                          ? "#2E7D32"
                          : "#333",
                      }}
                    >
                      Screening
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 14,
                      color: surchargeSelection?.screening
                        ? "#2E7D32"
                        : "#888",
                    }}
                  >
                    {fmtAmt(pScreen.reduce((s, c) => s + getA(c), 0))}
                  </Typography>
                </Box>
                <Box sx={{ px: 1.5, pb: 1 }}>
                  {pScreen.map((sc, si) => (
                    <Box
                      key={si}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 1,
                        pb: 1,
                        borderBottom:
                          si < pScreen.length - 1
                            ? `1px solid ${surchargeSelection?.screening
                              ? "#C8E6C9"
                              : "#F0F0F0"
                            }`
                            : "none",
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: 12, color: "#555" }}>
                          {sc?.name}
                        </Typography>
                        <Typography sx={{ fontSize: 11, color: "#888" }}>
                          {fmtKg(sc?.ratePerkilo)}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 500,
                          color: surchargeSelection?.screening
                            ? "#2E7D32"
                            : "#333",
                        }}
                      >
                        {fmtAmt(getA(sc))}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </>
          );
        })()}
      </Box>
    </Box>
  );
};

const Newratelisting = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const state = useSelector(updateStoredSearch);
  const loginedUser = useSelector(authuser)
  const userOfQueries = state?.payload?.newqueries?.newqueriesdata?.userDetails;

  const { newsearchformdata, rqueryid } = state?.payload?.newsearchform;
  const {
    productDetails,
    searchquery,
    requestType,
    apiCall,
    lowertempbound,
    temperatureRange,
    uppertempbound,
    airwaybillNumber,
    flightitinaries,
    ratesFrom,
    commodityGroup,
    commodityCode,
    commodity_description,
    isManualQuoted,
  } = newsearchformdata;

  // Manual-quote-only search: launched from the Queries page with
  // ?manualQuote=true in the URL (see Queries.jsx handleSeachFormdata). In this
  // mode the backend only returns the saved manual quote, so we listen for the
  // MQ_res socket alone (skipping every live airline/FS/offline event) and flag
  // the /ratesearch/all payload so the backend doesn't fan out to all providers.
  const isManualQuoteOnly =
    searchParams.get("manualQuote") === "true" || isManualQuoted;
  const {
    originAirport,
    originPort,
    destinationPort,
    destinationAirport,
    goodsDetails,
    packagingDetails,
    paymentTerms,
    cargoType,
    cass,
    preferred_airline,
    quoteExpiry,
  } = searchquery;
  const { searchratesAvailableData, originairports } =
    useSelector(searchratestate);
  const activeFilters = useSelector((state) => state?.filter?.filters);

  const selectedOriginAirport = (originAirport || originPort)?.originAirport;
  const originAirportObj = Array.isArray(originairports)
    ? originairports.find(
      (item) => `${item.cityName} - (${item.code})` === selectedOriginAirport
    )
    : null;
  const iataCassValue = cass || originAirportObj?.cass || "";

  // ─── Header commodity / temperature resolution ───────────────────────────
  // A "Quote Available" query can reach this page WITHOUT going through the
  // air search form — the Queries page (and the quotation email deep-link)
  // hand over `buildAirSearchPayload(queryDoc)`, which carries neither
  // `productDetails` nor a top-level `temperatureRange`. In that case the only
  // places the commodity/temperature exist are `searchquery.goodsDetails`
  // (goodsDetails.commodity_description) and the saved query document itself
  // (its top-level `temperatureRange`), which those same callers publish to
  // redux via `newqueries`.
  //
  // Purely additive fallbacks: every existing source is tried first and wins
  // unchanged, so the form-driven search paths behave exactly as before.
  const storedQueryDoc = state?.payload?.newqueries?.newqueriesdata;
  // Only trust the stored query document when it IS this search's query —
  // it survives in redux across navigations, so an unrelated fresh search
  // must never inherit a previously-opened query's commodity/temperature.
  const activeQueryId =
    searchquery?._id || newsearchformdata?.queryId || rqueryid;
  const storedQueryDocForThisSearch =
    storedQueryDoc?._id &&
      activeQueryId &&
      String(storedQueryDoc._id) === String(activeQueryId)
      ? storedQueryDoc
      : null;

  const headerCommodityDescription =
    commodity_description ||
    goodsDetails?.commodity_description ||
    props?.nodeData?.searchquery?.goodsDetails?.commodity_description ||
    storedQueryDocForThisSearch?.goodsDetails?.commodity_description ||
    storedQueryDocForThisSearch?.commodity_description ||
    "";

  const headerTemperatureRange =
    temperatureRange ||
    searchquery?.temperatureRange ||
    props?.nodeData?.searchquery?.temperatureRange ||
    props?.nodeData?.temperatureRange ||
    goodsDetails?.temperatureRange ||
    storedQueryDocForThisSearch?.temperatureRange ||
    "";

  // Manual-quote expiry (carried in from the Queries page). When the expiry
  // instant is at or before "now" (compared in IST via moment-timezone) the
  // quote has lapsed, so booking is no longer allowed — disable Book Now.
  const isQuoteExpired =
    !!quoteExpiry &&
    moment
      .tz(quoteExpiry, "Asia/Kolkata")
      .isSameOrBefore(moment.tz("Asia/Kolkata"));

  const [Qrbookingid, setQrbookingid] = useState();
  const [bookingId, setBookingId] = useState();
  const {
    queryId,
    bookingId: socketBookingId,
    setReceivingResponse,
    socket,
  } = useContext(ManageSocketContext);

  // Business verification (KYB) status from Redux — same source as the
  // PageLayout ribbon, which handles all the messaging. Only "approved" books
  // (src/utils/kyb.js); the booking routes enforce the same rule server-side.
  const kybStatus = useSelector(kybstatus);
  let kycAccepted = isKybApproved(kybStatus);

  // KAM and customer-side roles can also book once the query OWNER's business
  // verification is approved (users.kyb_verification_status on the query's
  // userDetails) — the logged-in user's own status isn't loaded reliably on a
  // cold deep-link to this results route.
  if (
    ["kam", "customer_admin", "customer"].includes(loginedUser?.userroles) &&
    isKybApproved(userOfQueries?.kyb_verification_status)
  ) {
    kycAccepted = true
  }


  const [receivingResponse, setLocalReceivingResponse] = useState(null);

  useEffect(() => {
    if (socketBookingId) dispatch(setBookingIdStore(socketBookingId));
  }, [socketBookingId, receivingResponse]);

  useEffect(() => {
    if (!socket) return;
    const safeParse = (data) => {
      if (typeof data === "string") {
        try {
          return JSON.parse(data);
        } catch (e) {
          return data;
        }
      }
      return data;
    };
    const onHasMore = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        hasmore: safeParse(data),
      }));
    const onHasMore1 = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        hasmore1: safeParse(data),
      }));
    const onOffline = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        OfflineRates_res: safeParse(data),
      }));
    const onManualQuote = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        MQ_res: safeParse(data),
      }));
    // Emitted by the backend alongside MQ_res on a manual-quote search — keep it
    // wired up in the same always-on set as MQ_res (not gated by
    // isManualQuoteOnly) so it's captured whenever the manual quote fires.
    const onMannualDummyData = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        Mannualdummydata: safeParse(data),
      }));
    const onQR = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        QR_res: safeParse(data),
      }));
    const onLH = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        LH_res: safeParse(data),
      }));
    const onTK = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        TK_res: safeParse(data),
      }));
    const onFS_AC = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_AC: safeParse(data),
      }));
    const onFS_BA = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_BA: safeParse(data),
      }));
    const onFS_TK = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_TK: safeParse(data),
      }));
    const onFS_AY = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_AY: safeParse(data),
      }));
    const onFS_VS = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_VS: safeParse(data),
      }));
    const onFS_LX = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_LX: safeParse(data),
      }));
    const onFS_AZ = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_AZ: safeParse(data),
      }));
    const onFS_KL = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_KL: safeParse(data),
      }));
    const onFS_AF = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_AF: safeParse(data),
      }));
    const onFS_EY = (data) =>
      setLocalReceivingResponse((prev) => ({
        ...prev,
        FS_EY: safeParse(data),
      }));
    // One handler per EK product event. Each product is stored under its own
    // event key so a later batch for one product never wipes another's rows.
    const ekHandlers = EK_RESULT_EVENTS.map((event) => [
      event,
      (data) => {
        const parsed = safeParse(data);
        console.log(`[EK] ${event}:`, parsed);
        // Backend already drops empty products; guard against a failed or
        // rate-less payload anyway so it can't add an empty entry.
        const hasRates = normalizeAirlineResponse(
          parsed?.airlineResponse
        ).some((g) => g?.availabilityResponseSOs?.length > 0);
        if (!parsed || parsed.success === false || !hasRates) return;
        setLocalReceivingResponse((prev) => ({ ...prev, [event]: parsed }));
      },
    ]);
    // EK failing must not block the other airlines — the loader and "no rates"
    // state are driven by hasmore, so just log it.
    const onEKError = (data) => console.error("[EK] EK_error:", safeParse(data));

    socket.on("hasmore", onHasMore);
    socket.on("hasmore1", onHasMore1);
    // MQ_res socket disabled — not consumed for now.
    // socket.on("MQ_res", onManualQuote);
    socket.on("Mannualdummydata", onMannualDummyData);
    // Manual-quote-only search (opened from Queries via ?manualQuote=true): the
    // backend emits only MQ_res, so don't wire up the live airline/FS/offline
    // listeners at all.
    if (!isManualQuoteOnly) {
      socket.on("QR_res", onQR);
      socket.on("LH_res", onLH);
      socket.on("TK_res", onTK);
      socket.on("FS_AC", onFS_AC);
      socket.on("FS_BA", onFS_BA);
      socket.on("FS_TK", onFS_TK);
      socket.on("FS_AY", onFS_AY);
      socket.on("FS_VS", onFS_VS);
      socket.on("FS_LX", onFS_LX);
      socket.on("FS_AZ", onFS_AZ);
      socket.on("FS_KL", onFS_KL);
      socket.on("FS_AF", onFS_AF);
      socket.on("FS_EY", onFS_EY);
      socket.on("OfflineRates_res", onOffline);
      ekHandlers.forEach(([event, handler]) => socket.on(event, handler));
      socket.on("EK_error", onEKError);
    }

    return () => {
      socket.off("hasmore", onHasMore);
      socket.off("hasmore1", onHasMore1);
      // MQ_res socket disabled — not consumed for now.
      // socket.off("MQ_res", onManualQuote);
      socket.off("Mannualdummydata", onMannualDummyData);
      if (!isManualQuoteOnly) {
        socket.off("QR_res", onQR);
        socket.off("LH_res", onLH);
        socket.off("TK_res", onTK);
        socket.off("FS_AC", onFS_AC);
        socket.off("FS_BA", onFS_BA);
        socket.off("FS_TK", onFS_TK);
        socket.off("FS_AY", onFS_AY);
        socket.off("FS_VS", onFS_VS);
        socket.off("FS_LX", onFS_LX);
        socket.off("FS_AZ", onFS_AZ);
        socket.off("FS_KL", onFS_KL);
        socket.off("FS_AF", onFS_AF);
        socket.off("FS_EY", onFS_EY);
        socket.off("OfflineRates_res", onOffline);
        ekHandlers.forEach(([event, handler]) => socket.off(event, handler));
        socket.off("EK_error", onEKError);
      }
    };
  }, [socket, isManualQuoteOnly]);

  const [queryid, setqueryid] = useState();
  const [airres, setAirres] = useState(false);
  const [mergedAirlineResponse, setMergedAirlineResponse] = useState([]);
  const [airlineresponselength, setAirlineresponselength] = useState({
    fs: null,
    in: null,
    qr: null,
    ek: null,
  });

  const manualStatusDispatched = useRef(false);
  const prevRqueryid = useRef(rqueryid);
  const [waitforfrieghtos, setwaitforfrieghtos] = useState(false);
  const [failureReady, setFailureReady] = useState(false);
  const [searchPending, setSearchPending] = useState(true);

  const availabilityResponseSOs = !airres
    ? mergedAirlineResponse?.airlineResponse
    : [];

  const surchargeSelection =
    useSelector((state) => state?.filter?.surchargeSelection) ?? {
      otherFees: false,
      screening: false,
    };

  const filteredAvailabilityResponseSOs = useMemo(() => {
    if (!availabilityResponseSOs?.length) return availabilityResponseSOs;
    if (!activeFilters?.filtersset) return availabilityResponseSOs;
    const {
      airlines,
      services,
      stops,
      ratePerKg,
      totalPrice,
      journeyDuration,
      category,
    } = activeFilters;
    const filtered = availabilityResponseSOs.map((dateGroup) => ({
      ...dateGroup,
      availabilityResponseSOs: (
        dateGroup?.availabilityResponseSOs || []
      ).filter((option) => {
        const itinerary = option?.flightItineraries?.[0];
        if (airlines?.length > 0) {
          const carrierName =
            option?.carrierName ||
            option?.flightItineraries?.[0]?.carrierName;
          if (!airlines.includes(carrierName)) return false;
        }
        if (category && services?.length === 0) return false;
        if (services?.length > 0) {
          const serviceName =
            itinerary?.rates_from === "FS" ||
            itinerary?.rates_from === "TK" ||
            isEkRate(option)
              ? option?.productDescription
              : option?.speedName;
          if (!services.includes(serviceName)) return false;
        }
        if (stops?.length > 0) {
          const numStops = (option?.flightItineraries?.length ?? 1) - 1;
          const stopLabel =
            numStops === 0
              ? "Direct"
              : numStops === 1
                ? "1 Stop"
                : `${numStops} Stops`;
          if (!stops.includes(stopLabel)) return false;
        }
        if (ratePerKg) {
          const rate = getDisplayRatePerKg(option);
          if (
            rate != null &&
            (rate < ratePerKg.min || rate > ratePerKg.max)
          )
            return false;
        }
        if (totalPrice) {
          const price = getDisplayTotals(option, surchargeSelection).total;
          if (
            price != null &&
            (price < totalPrice.min || price > totalPrice.max)
          )
            return false;
        }
        if (journeyDuration) {
          const travelHours = (option?.travelTime ?? 0) / 60;
          if (
            travelHours < journeyDuration.minHours ||
            travelHours > journeyDuration.maxHours
          )
            return false;
        }
        return true;
      }),
    }));
    return findMinRate(filtered);
  }, [
    availabilityResponseSOs,
    activeFilters,
    surchargeSelection?.otherFees,
    surchargeSelection?.screening,
  ]);

  const [error, seterror] = useState(false);
  const hasInchUnits =
    packagingDetails?.shipmentTotal?.unit === "CFT" ||
    (packagingDetails?.packagingType?.packages || []).some(
      (pkg) => pkg?.unit === "IN"
    );
  const [showMixedUnitsPopup, setShowMixedUnitsPopup] = useState(hasInchUnits);
  const { destinationPickup } =
    destinationAirport || destinationPort || {};
  const { originPickup } = originAirport || originPort || {};
  const [airportcode, setAirportcode] = useState({
    origincode: "",
    destinationcode: "",
  });
  const [selectedDate, setSelectedDate] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRows2, setExpandedRows2] = useState([]);
  const [indexTab, setTabIndex] = useState(0);
  const [show, setShow] = useState(0);
  const [open, setOpen] = useState(false);
  const [selecteddata, setSelecteddata] = useState({});
  // allowed_airline_list/35, fetched alongside every ratesearch/all call and
  // handed to the booking page to pick Submit Indent vs Proceed to Pay.
  const [allowedAirlines, setAllowedAirlines] = useState([]);
  const [viewBreakupData, setviewBreakupData] = useState({});
  const [openbooking, setOpenbooking] = useState(false);
  const [prevBookingAmount, setPrevBookingAmount] = useState(0);
  const [airports, setAirports] = useState([]);

  // Unverified-user search gate (utils/queryLimit). The search form already
  // stops these users before they get here; this catches the routes that land
  // on the results page directly (Queries page "Search Rates", ?queryId= links).
  const userDetails = useSelector((state) => state.data?.data?.data?.user);
  // getALLFlightRateSearch is memoised on [props] only, so it reads the user
  // through a ref instead of closing over a possibly stale /user-details value.
  const userDetailsRef = useRef(userDetails);
  userDetailsRef.current = userDetails;
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  // PageLayout's /user-details call can still be in flight on a direct load of
  // this page; the initial search waits for it (or for it to fail) so the gate
  // never runs against a missing profile. `data` starts as [] before any fetch.
  const profileReady = useSelector(
    (state) =>
      Boolean(state.data?.data?.data?.user) ||
      (!state.data?.loading &&
        (state.data?.error != null || !Array.isArray(state.data?.data)))
  );

  // ✅ kycAccepted useState and setKycAccepted removed — using Redux selector above

  const [chargePopover, setChargePopover] = useState({
    anchor: null,
    breakdown: [],
  });
  const [sortAnimKey, setSortAnimKey] = useState(null);
  const sortInitializedRef = useRef(false);

  const fetchAirports = async () => {
    try {
      const response = await httpinstance.get("airports");
      setAirports(response?.data?.data || []);
    } catch (err) { }
  };

  const airportMap = useMemo(
    () =>
      Object.fromEntries((airports || []).map((ap) => [ap.code, ap])),
    [airports]
  );

  useEffect(() => {
    fetchAirports();
  }, []);

  const currentTabItems =
    filteredAvailabilityResponseSOs?.[indexTab]?.availabilityResponseSOs || [];

  const sortedTabItems = useMemo(() => {
    const items = [...(currentTabItems || [])];
    const sortBy = activeFilters?.sortBy;
    if (!sortBy || sortBy === "default") return items;
    const asc = (v) =>
      v == null || isNaN(v) ? Infinity : Number(v);
    const desc = (v) =>
      v == null || isNaN(v) ? -Infinity : Number(v);
    if (sortBy === "cheapest_total")
      return items.sort(
        (a, b) =>
          asc(getDisplayTotals(a, surchargeSelection).total) -
          asc(getDisplayTotals(b, surchargeSelection).total)
      );
    if (sortBy === "cheapest_kg")
      return items.sort(
        (a, b) =>
          asc(getDisplayRatePerKg(a)) - asc(getDisplayRatePerKg(b))
      );
    if (sortBy === "fastest")
      return items.sort(
        (a, b) => asc(a?.travelTime) - asc(b?.travelTime)
      );
    if (sortBy === "slowest")
      return items.sort(
        (a, b) => desc(b?.travelTime) - desc(a?.travelTime)
      );
    return items;
  }, [
    currentTabItems,
    activeFilters?.sortBy,
    surchargeSelection?.otherFees,
    surchargeSelection?.screening,
  ]);

  const sortOrderSignature = useMemo(() => {
    const s = activeFilters?.sortBy || "default";
    if (s === "cheapest_total") {
      return `cheapest_total:${surchargeSelection?.otherFees ? 1 : 0}:${surchargeSelection?.screening ? 1 : 0
        }`;
    }
    return s;
  }, [
    activeFilters?.sortBy,
    surchargeSelection?.otherFees,
    surchargeSelection?.screening,
  ]);

  const tabDisplayMinRates = useMemo(() => {
    const map = {};
    (filteredAvailabilityResponseSOs || []).forEach((group, index) => {
      const list = group?.availabilityResponseSOs || [];
      let min = Infinity;
      for (const option of list) {
        const n = Number(
          getDisplayTotals(option, surchargeSelection).total
        );
        if (!isNaN(n) && n < min) min = n;
      }
      map[index] = min === Infinity ? 0 : min;
    });
    return map;
  }, [
    filteredAvailabilityResponseSOs,
    surchargeSelection?.otherFees,
    surchargeSelection?.screening,
  ]);

  const hasAnyData =
    availabilityResponseSOs?.some(
      (item) => item?.availabilityResponseSOs?.length > 0
    ) || false;

  useEffect(() => {
    if (!availabilityResponseSOs?.length) return;
    const firstValidIndex = availabilityResponseSOs.findIndex(
      (item) => item?.availabilityResponseSOs?.length > 0
    );
    if (firstValidIndex !== -1) {
      const currentIsValid =
        availabilityResponseSOs[selectedDate]?.availabilityResponseSOs
          ?.length > 0;
      if (!currentIsValid) {
        setSelectedDate(firstValidIndex);
        setTabIndex(firstValidIndex);
      }
    }
  }, [availabilityResponseSOs]);

  useEffect(() => {
    // Socket sends { hasMore: boolean }; fall back to legacy { data: boolean }.
    const hm = receivingResponse?.hasmore?.hasMore ?? receivingResponse?.hasmore?.data;
    if (hm === true || hm === false) setSearchPending(false);
  }, [receivingResponse?.hasmore]);

  // Socket sends { hasMore: boolean }; fall back to legacy { data: boolean }.
  const hasMore = receivingResponse?.hasmore?.hasMore ?? receivingResponse?.hasmore?.data;

  const failureConditionMet = hasMore === false && !hasAnyData && !searchPending;

  const rateStatusCalledRef = useRef(false);
  useEffect(() => {
    rateStatusCalledRef.current = false;
  }, [queryId, rqueryid]);

  useEffect(() => {
    if (hasMore !== false || searchPending) return;
    if (rateStatusCalledRef.current) return;
    // Manual-quote search (Quote_status "Manual Quoted" + requestType "1"): the
    // status is driven by the manual quote, so don't overwrite it with an
    // Auto Quoted / Quote Pending rate-status here. When Quote_status is anything
    // else, the rate-status call proceeds as normal.
    if (
      searchquery?.Quote_status === "Manual Quoted" &&
      String(requestType) === "1"
    )
      return;
    const resolvedQueryId = queryId || rqueryid;
    if (!resolvedQueryId) return;
    rateStatusCalledRef.current = true;
    const status = hasAnyData ? "Auto Quoted" : "Quote Pending";

    httpinstance
      .post("/rate-status", { queryId: resolvedQueryId, status })
      .catch(() => { });
  }, [hasMore, hasAnyData, searchPending, queryId, rqueryid, searchquery, requestType]);

  useEffect(() => {
    if (failureConditionMet) {
      const timer = setTimeout(() => setFailureReady(true), 20);
      return () => clearTimeout(timer);
    }
    setFailureReady(false);
  }, [failureConditionMet]);

  const isStillLoading = hasMore !== false || searchPending;
  const accumulatedResponsesRef = useRef([]);
  const lastSearchPayloadRef = useRef(null);
  const [initialPayloadReady, setInitialPayloadReady] = useState(false);
  const initialSearchStartedRef = useRef(false);

  function extractAirportCode(str) {
    const match = str?.match(/\(([^)]+)\)/);
    return match ? match[1] : "";
  }

  function transformData(data) {
    const updatedPackages =
      data?.packagingDetails?.packagingType?.packages?.map((pkg) => {
        const handling = pkg?.handling;
        const newPkg = { ...pkg };
        delete newPkg?.handling;
        if (handling === "Tiltable and Stackable") {
          newPkg.turnable = true;
          newPkg.stackable = true;
        } else if (handling === "Tiltable and Non-stackable") {
          newPkg.turnable = true;
          newPkg.stackable = false;
        } else if (handling === "Non-Tiltable and Stackable") {
          newPkg.turnable = false;
          newPkg.stackable = true;
        } else if (handling === "Non Tiltable and Non stackable") {
          newPkg.turnable = false;
          newPkg.stackable = false;
        }
        return newPkg;
      });
    return {
      ...data,
      packagingDetails: {
        ...data?.packagingDetails,
        packagingType: {
          ...data?.packagingDetails?.packagingType,
          packages: updatedPackages,
        },
      },
    };
  }

  useEffect(() => {
    accumulatedResponsesRef.current = [];
    const or = extractAirportCode(
      (originAirport || originPort)?.originAirport
    );
    const des = extractAirportCode(
      (destinationAirport || destinationPort)?.destinationAirport
    );
    setAirportcode({ origincode: or, destinationcode: des });
    let allcallpayloaddata = {
      cargoType,
      originAirport: originAirport || originPort,
      destinationAirport: destinationAirport || destinationPort,
      goodsDetails: {
        cargoreadydate: goodsDetails?.cargoreadydate,
        commodityId:
          productDetails?.commodityId || goodsDetails?.commodityId,
        commodityGroup:
          commodityGroup ||
          productDetails?.commodityGroup ||
          "General Cargo",
        commodityCode:
          commodityCode || goodsDetails?.commodityCode || "",
        specialHandlingCodes:
          productDetails?.specialHandlingCodes ||
          goodsDetails?.specialHandlingCodes,
        commodity_description:
          commodity_description ||
          productDetails?.natureOfGoods ||
          "",
      },
      packagingDetails,
      paymentTerms,
      requestType,
      lowertempbound,
      temperatureRange,
      uppertempbound,
    };
    // Only include preferred_airline when the user has actually selected one or
    // more carriers — otherwise omit the key entirely from the payload.
    if (Array.isArray(preferred_airline) && preferred_airline.length > 0) {
      allcallpayloaddata.preferred_airline = preferred_airline;
    }
    // Include the quote expiry (carried from the Queries page) when present.
    if (quoteExpiry) {
      allcallpayloaddata.quoteExpiry = quoteExpiry;
    }
    if (requestType == 2) {
      allcallpayloaddata.airlinePrefix =
        flightitinaries?.[0]?.airlinePrefix || null;
      allcallpayloaddata.ratesFrom = ratesFrom || null;
    }
    const result = transformData(allcallpayloaddata);
    let newresult;
    if (rqueryid || searchquery?._id) {
      newresult = {
        ...result,
        queryId: rqueryid
          ? rqueryid
          : searchquery?._id
            ? searchquery?._id
            : "",
      };
    }
    if (requestType === "2") {
      newresult = { ...result, queryId: rqueryid, airwaybillNumber };
    }
    const finalresult =
      rqueryid || searchquery?._id ? newresult : result;

    if (requestType === "2") {
      const updateQueryId = rqueryid || searchquery?._id;
      if (updateQueryId) {
        dispatch(getsinglebookingdata({ queryId: updateQueryId }))
          .then((res) => {
            const sbd = res?.payload?.data?.data;
            const existingBookingId =
              sbd?.bookeditem?.bookingId ?? sbd?.bookingId ?? null;
            const payloadToSend = existingBookingId
              ? { ...finalresult, bookingId: existingBookingId }
              : finalresult;
            lastSearchPayloadRef.current = {
              payload: payloadToSend,
              product: productDetails,
            };
            setInitialPayloadReady(true);
          })
          .catch(() => {
            lastSearchPayloadRef.current = {
              payload: finalresult,
              product: productDetails,
            };
            setInitialPayloadReady(true);
          });
        return;
      }
    }

    lastSearchPayloadRef.current = {
      payload: finalresult,
      product: productDetails,
    };
    setInitialPayloadReady(true);
  }, []);

  // Runs the initial search once both the payload and the profile are ready.
  useEffect(() => {
    if (!initialPayloadReady || !profileReady || initialSearchStartedRef.current)
      return;
    initialSearchStartedRef.current = true;
    const { payload, product } = lastSearchPayloadRef.current;
    getALLFlightRateSearch(payload, product);
  }, [initialPayloadReady, profileReady]);

  // The email was just verified, so the blocked search is retried without
  // re-checking the limit (the refreshed profile may not have rendered yet).
  const handleEmailVerified = () => {
    setShowVerifyModal(false);
    const last = lastSearchPayloadRef.current;
    if (last) getALLFlightRateSearch(last.payload, last.product, { skipLimitCheck: true });
  };

  useEffect(() => {
    dispatch(
      setBookingdata({
        qrbookingid: Qrbookingid,
        frieghtosbookingid: bookingId,
      })
    );
  }, [Qrbookingid, bookingId]);

  const mergeAndUpdateState = useCallback(
    (newDateGrouped, metaObj) => {
      accumulatedResponsesRef.current = [
        ...accumulatedResponsesRef.current,
        ...newDateGrouped,
      ];
      const merged = mergeDataBasedOnDate(accumulatedResponsesRef.current);
      const filtered = merged.map((item) => ({
        ...item,
        availabilityResponseSOs: (
          item?.availabilityResponseSOs || []
        ).filter(
          (so) =>
            so?.origin === airportcode?.origincode &&
            so?.destination === airportcode?.destinationcode
        ),
      }));
      const withRates = findMinRate(filtered);
      const finalResult = { ...metaObj, airlineResponse: withRates };
      setMergedAirlineResponse(finalResult);
      dispatch(setsearchratesAvailableData(finalResult));
    },
    [airportcode, dispatch]
  );

  useEffect(() => {
    if (receivingResponse == null) return;
    const { OfflineRates_res, TK_res, LH_res, QR_res, MQ_res, Mannualdummydata } =
      receivingResponse;
    console.log(OfflineRates_res, "OfflineRates_res");
    if (queryId) {
      dispatch(updatequeryid(queryId));
      setqueryid(queryId);
    }
    const ekResponses = EK_RESULT_EVENTS.map(
      (event) => receivingResponse[event]
    ).filter(Boolean);
    const mergedAirlineRes =
      OfflineRates_res ||
      TK_res ||
      LH_res ||
      QR_res ||
      ekResponses[0] ||
      MQ_res ||
      Mannualdummydata;
    const newDateGrouped = [];
    const offlineNormalized = normalizeAirlineResponse(
      OfflineRates_res?.airlineResponse
    );
    if (offlineNormalized.length > 0) {
      const totalSOs = offlineNormalized.reduce(
        (sum, g) => sum + (g?.availabilityResponseSOs?.length || 0),
        0
      );
      setAirlineresponselength((prev) =>
        prev.in === totalSOs ? prev : { ...prev, in: totalSOs }
      );
      newDateGrouped.push(...offlineNormalized);
    } else if (OfflineRates_res && offlineNormalized.length === 0) {
      setAirlineresponselength((prev) => (prev.in === 0 ? prev : { ...prev, in: 0 }));
    }
    const tkNormalized = normalizeAirlineResponse(TK_res?.airlineResponse);
    if (tkNormalized.length > 0) newDateGrouped.push(...tkNormalized);
    const lhNormalized = normalizeAirlineResponse(LH_res?.airlineResponse);
    if (lhNormalized.length > 0) newDateGrouped.push(...lhNormalized);
    const ekNormalized = ekResponses.flatMap((r) =>
      normalizeAirlineResponse(r?.airlineResponse)
    );
    if (ekNormalized.length > 0) {
      const totalEKSOs = ekNormalized.reduce(
        (sum, g) => sum + (g?.availabilityResponseSOs?.length || 0),
        0
      );
      setAirlineresponselength((prev) =>
        prev.ek === totalEKSOs ? prev : { ...prev, ek: totalEKSOs }
      );
      newDateGrouped.push(...ekNormalized);
    }
    const prevAmt1 =
      LH_res?.prevBookingAmount ||
      QR_res?.prevBookingAmount ||
      OfflineRates_res?.prevBookingAmount ||
      ekResponses.find((r) => r?.prevBookingAmount)?.prevBookingAmount ||
      0;
    setPrevBookingAmount(prevAmt1);
    if (requestType === "2") {
      dispatch(setPrevBookingAmountStore(prevAmt1));
    } else {
      dispatch(clearPrevBookingAmountStore());
    }
    const qrNormalized = normalizeAirlineResponse(QR_res?.airlineResponse);
    if (qrNormalized.length > 0) {
      const totalQRSOs = qrNormalized.reduce(
        (sum, g) => sum + (g?.availabilityResponseSOs?.length || 0),
        0
      );
      setAirlineresponselength((prev) =>
        prev.qr === totalQRSOs ? prev : { ...prev, qr: totalQRSOs }
      );
      newDateGrouped.push(...qrNormalized);
    } else if (QR_res && qrNormalized.length === 0) {
      setAirlineresponselength((prev) => (prev.qr === 0 ? prev : { ...prev, qr: 0 }));
    }
    const mqNormalized = normalizeAirlineResponse(MQ_res?.airlineResponse);
    if (mqNormalized.length > 0) newDateGrouped.push(...mqNormalized);
    // Mannualdummydata is emitted alongside MQ_res — merge its rows in too. The
    // listing renders one departure-date tab at a time, so if a manual quote is
    // present, fold the dummy rows under the SAME date group as MQ so they show
    // together in one listing (each row's own flight itinerary/date is unchanged;
    // only the tab grouping is unified). With no MQ, keep their own dates.
    const mqDummyNormalized = normalizeAirlineResponse(
      Mannualdummydata?.airlineResponse
    );
    if (mqDummyNormalized.length > 0) {
      const mqTargetDate = mqNormalized?.[0]?.departureDate;
      if (mqTargetDate) {
        const dummySOs = mqDummyNormalized.flatMap(
          (g) => g?.availabilityResponseSOs || []
        );
        newDateGrouped.push({
          departureDate: mqTargetDate,
          availabilityResponseSOs: dummySOs,
        });
      } else {
        newDateGrouped.push(...mqDummyNormalized);
      }
    }
    if (newDateGrouped.length > 0)
      mergeAndUpdateState(newDateGrouped, mergedAirlineRes || {});
  }, [receivingResponse, hasMore, searchquery, mergeAndUpdateState]);

  useEffect(() => {
    const fsKeys = [
      "FS_AC", "FS_BA", "FS_TK", "FS_AY", "FS_VS",
      "FS_LX", "FS_AZ", "FS_AF", "FS_KL", "FS_EY",
    ];
    const fsResponses = fsKeys
      .map((key) => receivingResponse?.[key])
      .filter(Boolean);
    const hasAnyFSData = fsResponses.length > 0;
    if (hasAnyFSData) {
      setwaitforfrieghtos(false);
      const freightosData = fsResponses[0];
      const combinedFSRaw = fsResponses.flatMap((r) => {
        const normalized = normalizeAirlineResponse(r?.airlineResponse);
        return normalized.flatMap(
          (g) => g?.availabilityResponseSOs || []
        );
      });
      const fsDateGrouped = normalizeAirlineResponse({
        availabilityResponseSOs: combinedFSRaw,
      });
      const mergedFreightosData = {
        ...freightosData,
        airlineResponse: combinedFSRaw,
      };
      const prevAmt2 = mergedFreightosData?.prevBookingAmount ?? 0;
      setPrevBookingAmount(prevAmt2);
      if (requestType === "2") {
        dispatch(setPrevBookingAmountStore(prevAmt2));
      } else {
        dispatch(clearPrevBookingAmountStore());
      }
      dispatch(
        updatebookingid(mergedFreightosData?.bookingId || "234")
      );
      if (combinedFSRaw.length > 0) {
        setAirres(false);
        setAirlineresponselength((prev) =>
          prev.fs === combinedFSRaw.length
            ? prev
            : { ...prev, fs: combinedFSRaw.length }
        );
        mergeAndUpdateState(fsDateGrouped, mergedFreightosData);
      } else {
        setAirlineresponselength((prev) => (prev.fs === 0 ? prev : { ...prev, fs: 0 }));
      }
    } else if (
      airlineresponselength?.in == null &&
      airlineresponselength?.fs == null &&
      airlineresponselength?.qr == null &&
      airlineresponselength?.ek == null &&
      hasMore &&
      !hasAnyFSData
    ) {
      setwaitforfrieghtos(true);
    }
  }, [
    receivingResponse,
    airlineresponselength,
    hasMore,
    mergeAndUpdateState,
  ]);

  useEffect(() => {
    if (prevRqueryid.current !== rqueryid) {
      manualStatusDispatched.current = false;
      prevRqueryid.current = rqueryid;
    }
    if (
      airlineresponselength?.in == 0 &&
      airlineresponselength?.fs == 0 &&
      airlineresponselength?.qr == 0 &&
      // EK only emits when it has rates, so any EK count means we're quoted.
      !(airlineresponselength?.ek > 0) &&
      newsearchformdata?.requestType == "1" &&
      !manualStatusDispatched.current
    ) {
      manualStatusDispatched.current = true;
      dispatch(manualstatus(rqueryid));
    }
  }, [airlineresponselength, rqueryid]);

  const getALLFlightRateSearch = useCallback(
    async (allcallpayloaddata, product, { skipLimitCheck = false } = {}) => {
      let finalUpdatedPayload;
      const shc =
        allcallpayloaddata?.goodsDetails?.specialHandlingCodes || [];
      const condition =
        shc.includes("PEP") || shc.includes("PER");
      const condition2 = product?.productCode === "QFR";
      const condition3 = allcallpayloaddata?.temperatureRange || false;
      const isPerishableTempControlled =
        allcallpayloaddata?.goodsDetails?.commodityGroup?.toLowerCase() ===
        "perishables" && !!condition3;
      const isPerishablesNoTemp =
        allcallpayloaddata?.goodsDetails?.commodityGroup?.toLowerCase() ===
        "perishables no temp";
      const hasTempBounds =
        allcallpayloaddata?.uppertempbound != null &&
        allcallpayloaddata?.uppertempbound !== "" &&
        allcallpayloaddata?.lowertempbound != null &&
        allcallpayloaddata?.lowertempbound !== "";
      const newUpdatePayload = {
        ...allcallpayloaddata,
        pharmaDtls: { pharmaReqType: "Care", isPassive: false },
      };
      const newUpdatePayload2 = {
        ...allcallpayloaddata,
        pharmaDtls: {
          pharmaReqType: "Passive",
          // Shared with the booking payload builder so the frozen "-10"
          // set-point nulls its temperature fields identically in both — the
          // form stores -10/-30 for that option, but it is a set-point rather
          // than a from/to window and those bounds must not go out.
          passivePharmaDtl: buildPassivePharmaDtl(allcallpayloaddata),
          isPassive: true,
        },
      };
      if (
        (condition === true && condition2 === true && condition3) ||
        (condition === false && condition2 === true)
      ) {
        finalUpdatedPayload = newUpdatePayload2;
      } else if (
        condition === true &&
        condition2 === true &&
        condition3 === false
      ) {
        finalUpdatedPayload = newUpdatePayload;
      } else if (isPerishableTempControlled) {
        finalUpdatedPayload = newUpdatePayload2;
      } else if (isPerishablesNoTemp && hasTempBounds) {
        finalUpdatedPayload = newUpdatePayload2;
      } else {
        finalUpdatedPayload = allcallpayloaddata;
      }
      const tempRange = allcallpayloaddata?.temperatureRange;
      if (tempRange === "2-8") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails
                ?.specialHandlingCodes || []),
              "COL",
            ],
          },
        };
      } else if (tempRange === "15-25") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails
                ?.specialHandlingCodes || []),
              "CRT",
            ],
          },
        };
      } else if (tempRange === "2-25") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails
                ?.specialHandlingCodes || []),
              "ERT",
            ],
          },
        }}
        else if (tempRange === "-10") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails
                ?.specialHandlingCodes || []),
              "PER",
            ],
          },
        };
      }

      // ✅ KYC check removed — no local /get_kyc call, no toasts
      // kycAccepted is now derived from Redux state (state.usersection.kyb_verification_status)

      const combinednewpayload = {
        ...finalUpdatedPayload,
        iataCass: iataCassValue,
        // Manual-quote rate search (the magnifying-glass "Search Rates" action on
        // the Queries page sets isManualQuoted / searchquery.Quote_status): send
        // the quote status so /ratesearch/all returns the manual-quote rates.
        ...(isManualQuoted
          ? { Quote_status: searchquery?.Quote_status || "Manual Quoted" }
          : {}),
        // Manual-quote-only search (?manualQuote=true from the Queries page):
        // tell the backend not to fan out to all providers/sockets — only the
        // saved manual quote (MQ_res) is needed.
        ...(isManualQuoteOnly ? { manualQuoteOnly: true } : {}),
        packagingDetails: {
          ...finalUpdatedPayload?.packagingDetails,
          shipmentTotal: {
            ...finalUpdatedPayload?.packagingDetails?.shipmentTotal,
            type: finalUpdatedPayload?.packagingDetails?.packagingType
              ?.weightMode,
          },
        },
      };
      try {
        setSearchPending(true);
        accumulatedResponsesRef.current = [];
        setMergedAirlineResponse([]);
        // Drop the previous search's EK products so they can't be re-merged
        // into this search's results.
        setLocalReceivingResponse((prev) => {
          if (!prev) return prev;
          const next = { ...prev };
          EK_RESULT_EVENTS.forEach((event) => delete next[event]);
          return next;
        });
        setAirlineresponselength((prev) => ({ ...prev, ek: null }));
        dispatch(clearFilters());
        // Unverified customers past their free searches: skip the rate search
        // (and the allowed-airline list) and ask them to verify instead.
        if (!skipLimitCheck && (await isQueryLimitReached(userDetailsRef.current))) {
          setSearchPending(false);
          setShowVerifyModal(true);
          return;
        }
        httpinstance
          .get("allowed_airline_list/35")
          .then((res) => {
            const payload = res?.data?.data;
            const list = Array.isArray(payload) ? payload : payload?.data || [];
            setAllowedAirlines(list.filter(Boolean));
          })
          .catch((err) => console.error("Failed to load allowed airlines:", err));
        await httpinstance.post("ratesearch/all", combinednewpayload);
      } catch (err) { }
    },
    [props]
  );

  const handleDateChange = (event, newValue) => {
    setSelectedDate(newValue);
    setTabIndex(newValue);
    // Collapse any expanded itinerary cards when switching tabs, so a card left
    // open on one date isn't still open when the user comes back to it.
    setExpandedRows([]);
    setExpandedRows2([]);
  };
  const toggleRow = (index) =>
    setExpandedRows((prev) =>
      prev.includes(index) ? [] : [index]
    );
  const toggleRow2 = (index) =>
    setExpandedRows2((prev) =>
      prev.includes(index) ? [] : [index]
    );

  const convertMinutesToHoursAndMinutes = (totalMinutes) => {
    const parsed = Number(totalMinutes);
    if (!totalMinutes || isNaN(parsed)) return "-";
    const hours = Math.floor(parsed / 60);
    const minutes = parsed % 60;
    return `${hours}h ${minutes}m`;
  };

  const checkForKam_user = () => {
    if (props?.role_type != undefined) return !props?.role_type;
    else if (
      props?.nodeData?.isExpired != undefined &&
      props?.nodeData?.isExpired
    )
      return props?.nodeData?.isExpired;
    return false;
  };

  const convertMinutesToDaysHoursMinutes = (totalMinutes) => {
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    return `${days}d ${hours}h ${minutes}m`;
  };

  const computeDisplayRate = useCallback((option, selection) => {
    const ratesFrom =
      option?.flightItineraries?.[0]?.rates_from
        ? option?.flightItineraries?.[0]?.rates_from
        : option?.ratesFrom;
    const breakdown = option?.rateDetails?.chargesBreakDown || [];
    const fmtLabel = (n) =>
      n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    // Non-FS rates (QR / TK / LH / offline / stored) carry a flat break-down:
    //   { chargeType, chargeCode, chargeDescription, chargeAmount }
    // Show the break-up whenever it exists — even if only a freight charge is
    // present. Freight is matched the same way ChargesModal does.
    if (ratesFrom !== "FS" && ratesFrom !== "manualQoute") {
      const num = (v) => Number(v) || 0;
      const isFreight = (c) =>
        !!(
          c?.chargeType?.toLowerCase?.()?.includes?.("freight") ||
          c?.chargeCode?.toLowerCase?.() === "frt" ||
          c?.chargeType?.toLowerCase?.() === "basic freight"
        );
      // Only flat-shaped items carry chargeAmount; ignore anything else so a
      // stray category-shaped entry can't leak in as a ₹0 surcharge.
      const flatItems = breakdown.filter((c) => c?.chargeAmount != null);
      const freightItems = flatItems.filter(isFreight);
      const surchargeItems = flatItems.filter((c) => !isFreight(c));
      const freightTotal = freightItems.reduce(
        (s, c) => s + num(c?.chargeAmount),
        0
      );
      const surchargeTotal = surchargeItems.reduce(
        (s, c) => s + num(c?.chargeAmount),
        0
      );

      const chargeLines = [];
      if (freightItems.length) {
        chargeLines.push({
          key: "freight",
          label: "Freight Charge",
          amount: freightTotal,
        });
      }
      if (surchargeItems.length) {
        chargeLines.push({
          key: "other",
          label: "Other Charges",
          amount: surchargeTotal,
        });
      }

      // "ALL IN" rates carry no itemised break-down — surface the all-in total
      // as the freight charge instead of showing a bare dash.
      if (!chargeLines.length) {
        const allInAmount = num(option?.rateDetails?.totalAmount);
        if (allInAmount) {
          chargeLines.push({
            key: "freight",
            label: "Freight Charge",
            amount: allInAmount,
          });
        }
      }

      return {
        totalAmount: option?.rateDetails?.totalAmount,
        ratePerkilo: option?.rateDetails?.ratePerkilo,
        airFreightRatePerkilo: option?.rateDetails?.ratePerkilo,
        surchargeLabel: "ALL IN",
        showInfoIcon: chargeLines.length > 0,
        chargeLines,
        selectedBreakdown: breakdown,
      };
    }

    const mainCharge = breakdown.find((c) => c.category === "Main");
    const fuelSecCharges = breakdown.filter(
      (c) => c.category === "Fuel" || c.category === "Security"
    );
    const otherCharges = breakdown.filter(
      (c) => c.category === "Other taxes"
    );
    const screeningCharges = breakdown.filter(
      (c) => c.category === "Screening"
    );
    const hasNonMain =
      fuelSecCharges.length ||
      otherCharges.length ||
      screeningCharges.length;

    const getAmt = (c) => c?.Totalamount ?? c?.totalAmount ?? 0;

    const airFreightRatePerkilo =
      mainCharge?.ratePerkilo ?? option?.rateDetails?.ratePerkilo;

    const mainAmt = mainCharge
      ? getAmt(mainCharge)
      : option?.rateDetails?.totalAmount ?? 0;
    const fuelSecTotal = fuelSecCharges.reduce((s, c) => s + getAmt(c), 0);
    const otherTotal = otherCharges.reduce((s, c) => s + getAmt(c), 0);
    const screeningTotal = screeningCharges.reduce(
      (s, c) => s + getAmt(c),
      0
    );

    // Individual charge components rendered inline under the "Surcharges"
    // column so the rate break-up is visible without opening the popover.
    const chargeLines = [];
    if (mainCharge || mainAmt) {
      chargeLines.push({
        key: "freight",
        label: "Freight Charge",
        amount: mainAmt,
      });
    }
    if (fuelSecCharges.length) {
      chargeLines.push({
        key: "fuel",
        label: "Fuel & Security",
        amount: fuelSecTotal,
      });
    }
    if (otherCharges.length) {
      chargeLines.push({
        key: "other",
        label: "Other Charges",
        amount: otherTotal,
      });
    }
    if (screeningCharges.length) {
      chargeLines.push({
        key: "screening",
        label: "Screening",
        amount: screeningTotal,
      });
    }

    if (!hasNonMain) {
      return {
        totalAmount:
          mainCharge?.Totalamount ??
          mainCharge?.totalAmount ??
          option?.rateDetails?.totalAmount,
        ratePerkilo:
          mainCharge?.ratePerkilo ?? option?.rateDetails?.ratePerkilo,
        airFreightRatePerkilo,
        surchargeLabel: "ALL IN",
        showInfoIcon: !!mainCharge,
        chargeLines,
        selectedBreakdown: mainCharge ? [mainCharge] : [],
      };
    }

    const mainKg = mainCharge
      ? mainCharge?.ratePerkilo ?? 0
      : option?.rateDetails?.ratePerkilo ?? 0;

    let total = mainAmt + fuelSecTotal;
    let perKg =
      mainKg +
      fuelSecCharges.reduce((s, c) => s + (c?.ratePerkilo ?? 0), 0);
    let addedSum = 0;

    if (selection?.otherFees && otherCharges.length) {
      total += otherTotal;
      addedSum += otherTotal;
      perKg += otherCharges.reduce(
        (acc, c) => acc + (c?.ratePerkilo ?? 0),
        0
      );
    }
    if (selection?.screening && screeningCharges.length) {
      total += screeningTotal;
      addedSum += screeningTotal;
      perKg += screeningCharges.reduce(
        (acc, c) => acc + (c?.ratePerkilo ?? 0),
        0
      );
    }

    const hasUnselectedExtras =
      (otherCharges.length > 0 && !selection?.otherFees) ||
      (screeningCharges.length > 0 && !selection?.screening);
    const surchargeDisplayTotal = fuelSecTotal + addedSum;

    const selectedBreakdown = [
      ...(mainCharge ? [mainCharge] : []),
      ...fuelSecCharges,
      ...(selection.otherFees ? otherCharges : []),
      ...(selection.screening ? screeningCharges : []),
    ];

    return {
      totalAmount: total,
      ratePerkilo: perKg,
      airFreightRatePerkilo,
      surchargeLabel:
        surchargeDisplayTotal > 0
          ? `₹${fmtLabel(surchargeDisplayTotal)}${hasUnselectedExtras ? " (+)" : ""
          }`
          : hasUnselectedExtras
            ? "ALL IN (+)"
            : "ALL IN",
      showInfoIcon: true,
      chargeLines,
      selectedBreakdown,
    };
  }, []);

  const toggleOtherFees = useCallback(
    () =>
      dispatch(
        setSurchargeSelection({
          ...surchargeSelection,
          otherFees: !surchargeSelection.otherFees,
        })
      ),
    [surchargeSelection, dispatch]
  );
  const toggleScreening = useCallback(
    () =>
      dispatch(
        setSurchargeSelection({
          ...surchargeSelection,
          screening: !surchargeSelection.screening,
        })
      ),
    [surchargeSelection, dispatch]
  );

  useEffect(() => {
    if (!sortInitializedRef.current) {
      sortInitializedRef.current = true;
      return;
    }
    setSortAnimKey((k) => (k ?? 0) + 1);
  }, [sortOrderSignature]);

  const handleCheckBooking = (option) => {
    setSelecteddata(option);
    setReceivingResponse(null);
    navigate("/search-rates/new-booking-confirmation", {
      state: { selectedItem: option, surchargeSelection, allowedAirlines },
    });
  };

  const countFlightsForDate = (dateIndex) =>
    filteredAvailabilityResponseSOs?.[dateIndex]?.availabilityResponseSOs
      ?.length || 0;

  const handleback = () => {
    setAirres(true);
    accumulatedResponsesRef.current = [];
    clearSearchRateAvailableData();
    setReceivingResponse(null);
    dispatch(clearFilters());
    dispatch(clearSurchargeSelection());
    // The other half of the same problem: an ocean "Edit Query" also parks its
    // prefill in searchrates.data, and NewSearchRates falls back to that
    // prefill's cargoType to pick the mode tab. Only a manual tab switch
    // (clearstate) ever clears it, so a leftover ocean prefill would put this
    // AIR back-navigation on the Ocean tab. This is the air results page — any
    // ocean prefill here is stale by definition.
    dispatch(clearOceanSearchForm());
    navigate(-1);
  };

  const redirectToeditManualQuote = () => {
    dispatch(
      getManualQuoteDetailById(props?.nodeData?.manualQuoteId)
    ).then((res) => {
      const payload = {
        manualQuoteDetails: res?.payload?.nodeData,
        queryDetails: res?.payload?.nodeData?.queryId,
      };
      dispatch(setManualQuoteDetail(payload));
      navigate("/send-manual-quote-v2");
    });
  };

  const filterData = useMemo(() => {
    if (!mergedAirlineResponse?.airlineResponse?.length) return null;
    const carriers = new Set();
    const services = new Map();
    const rateTypes = new Set();
    let minPrice = Number.POSITIVE_INFINITY,
      maxPrice = Number.NEGATIVE_INFINITY;
    let minTravelTime = Number.POSITIVE_INFINITY,
      maxTravelTime = Number.NEGATIVE_INFINITY;
    let minRatePerKilo = Number.POSITIVE_INFINITY,
      maxRatePerKilo = Number.NEGATIVE_INFINITY;
    const stops = new Set();
    mergedAirlineResponse?.airlineResponse?.forEach((dateItem) => {
      dateItem?.availabilityResponseSOs?.forEach((option) => {
        const firstFlight =
          option?.carrierName ||
          option?.flightItineraries?.[0]?.carrierName;
        if (firstFlight) carriers.add(firstFlight);
        const itinerary = option?.flightItineraries?.[0];
        if (itinerary) {
          const serviceName =
            itinerary?.rates_from === "FS" ||
              itinerary?.rates_from === "TK" ||
              isEkRate(option)
              ? option?.productDescription
              : option?.speedName;
          const carrierName = itinerary?.carrierName;
          if (serviceName && carrierName) {
            const key = `${serviceName}_${carrierName}`;
            services.set(key, {
              id: services.size + 1,
              service: serviceName,
              carrname: carrierName,
            });
          }
        }
        if (option?.rateDetails?.rateType)
          rateTypes.add(option.rateDetails.rateType);
        const price = getDisplayTotals(option, surchargeSelection).total;
        if (price != null && !isNaN(Number(price))) {
          minPrice = Math.min(minPrice, price);
          maxPrice = Math.max(maxPrice, price);
        }
        const ratePerKilo = getDisplayRatePerKg(option);
        if (ratePerKilo != null && !isNaN(Number(ratePerKilo))) {
          minRatePerKilo = Math.min(minRatePerKilo, ratePerKilo);
          maxRatePerKilo = Math.max(maxRatePerKilo, ratePerKilo);
        }
        const travelTime = option?.travelTime;
        if (travelTime != null) {
          minTravelTime = Math.min(minTravelTime, travelTime);
          maxTravelTime = Math.max(maxTravelTime, travelTime);
        }
        const numStops = option?.flightItineraries?.length - 1;
        if (numStops === 0) stops.add("Direct");
        else if (numStops === 1) stops.add("1 Stop");
        else if (numStops > 1) stops.add(`${numStops} Stops`);
      });
    });
    return {
      carriers: Array.from(carriers).sort(),
      services: Array.from(services.values()),
      rateTypes: Array.from(rateTypes).sort(),
      priceRange: {
        min:
          minPrice === Number.POSITIVE_INFINITY ? 0 : minPrice,
        max:
          maxPrice === Number.NEGATIVE_INFINITY ? 0 : maxPrice,
      },
      ratePerKiloRange: {
        min:
          minRatePerKilo === Number.POSITIVE_INFINITY
            ? 0
            : minRatePerKilo,
        max:
          maxRatePerKilo === Number.NEGATIVE_INFINITY
            ? 0
            : maxRatePerKilo,
      },
      travelTimeRange: {
        min:
          minTravelTime === Number.POSITIVE_INFINITY
            ? 0
            : minTravelTime,
        max:
          maxTravelTime === Number.NEGATIVE_INFINITY
            ? 0
            : maxTravelTime,
      },
      stops: Array.from(stops).sort(),
    };
  }, [
    mergedAirlineResponse,
    surchargeSelection?.otherFees,
    surchargeSelection?.screening,
  ]);

  useEffect(() => {
    dispatch(setFilterData(filterData));
  }, [filterData, receivingResponse?.hasmore]);

  // ─── Failure state ────────────────────────────────────────────
  if (failureReady) {
    return (
      <>
        <Box
          sx={{ padding: 2, backgroundColor: "#f5f5f5" }}
          className="edit_queryMain"
        >
          {props?.role_type != undefined && !props?.role_type ? null : (
            <QueryHeaderBand
              airportcode={airportcode}
              originAirport={originAirport}
              originPort={originPort}
              destinationAirport={destinationAirport}
              destinationPort={destinationPort}
              goodsDetails={goodsDetails}
              productDetails={productDetails}
              commodityGroup={commodityGroup}
              commodityDescription={headerCommodityDescription}
              packagingDetails={packagingDetails}
              temperatureRange={headerTemperatureRange}
              navigate={navigate}
              handleback={handleback}
              roleType={props?.role_type}
              image={props?.image}
              nodeData={props?.nodeData}
              convertMinutesToDaysHoursMinutes={
                convertMinutesToDaysHoursMinutes
              }
              isManualQuoted={isManualQuoted}
              isFailure
            />
          )}
        </Box>
        <Box
          sx={{
            margin: 3,
            borderRadius: 4,
            backgroundColor: "white",
            border: "1px solid white",
          }}
        >
          <FailureSearchRate />
        </Box>
      </>
    );
  }

  return (
    <>
      <GlobalStyles
        styles={{
          "@keyframes sortCardIn": {
            "0%": {
              opacity: 0,
              transform: "translateY(-16px) scale(0.97)",
            },
            "60%": { opacity: 1 },
            "100%": {
              opacity: 1,
              transform: "translateY(0)    scale(1)",
            },
          },
        }}
      />
      {/* ✅ ToastContainer removed — KYC messaging handled by ribbon in PageLayout */}
      <Box
        sx={{ padding: 2, backgroundColor: "#f5f5f5" }}
        className="searchRatesResultMain"
      >
        <div className="BoxDetailFlex">
          <div className="LeftFilters">
            <FilterForm onClose={() => { }} />
          </div>
          <div className="boxRightData">
            {props?.role_type != undefined && !props?.role_type ? null : (
              <QueryHeaderBand
                airportcode={airportcode}
                originAirport={originAirport}
                originPort={originPort}
                destinationAirport={destinationAirport}
                destinationPort={destinationPort}
                goodsDetails={goodsDetails}
                productDetails={productDetails}
                commodityGroup={commodityGroup}
                commodityDescription={headerCommodityDescription}
                packagingDetails={packagingDetails}
                temperatureRange={headerTemperatureRange}
                navigate={navigate}
                handleback={handleback}
                roleType={props?.role_type}
                image={props?.image}
                nodeData={props?.nodeData}
                convertMinutesToDaysHoursMinutes={
                  convertMinutesToDaysHoursMinutes
                }
                isManualQuoted={isManualQuoted}
                surchargeSelection={surchargeSelection}
                toggleOtherFees={toggleOtherFees}
                toggleScreening={toggleScreening}
              />
            )}



            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              <Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "white",
                    padding: "12px 16px",
                    borderRadius: "12px",
                    border: "1px solid #f0ede8",
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
                    <Tabs
                      value={hasAnyData ? selectedDate : -1}
                      onChange={handleDateChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      sx={{
                        minHeight: "unset",
                        "& .MuiTabs-indicator": { display: "none" },
                      }}
                    >
                      {availabilityResponseSOs?.map((item, index) => {
                        if (!item?.availabilityResponseSOs?.length)
                          return null;
                        const date = moment(
                          item?.availabilityResponseSOs[0]
                            ?.flightItineraries?.[0]?.scheduledDepartureDate
                        );
                        const filteredItem =
                          filteredAvailabilityResponseSOs?.[index];
                        const displayCount =
                          filteredItem?.rates_count ?? 0;
                        const displayMinRate =
                          tabDisplayMinRates[index] ?? 0;
                        const isActive = selectedDate === index;
                        return (
                          <Tab
                            key={index}
                            value={index}
                            disableRipple
                            sx={{
                              minHeight: "unset",
                              padding: 0,
                              marginRight: "10px",
                            }}
                            label={
                              <Box
                                sx={{
                                  minWidth: 90,
                                  padding: "8px 14px",
                                  borderRadius: "8px",
                                  border: isActive
                                    ? "2px solid #4CAF50"
                                    : "1px solid #f0f0f0",
                                  backgroundColor: isActive
                                    ? "#F1F8E9"
                                    : "white",
                                  textAlign: "center",
                                  position: "relative",
                                  transition: "all 0.2s",
                                  cursor: "pointer",
                                }}
                              >
                                {isActive && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: 6,
                                      right: 6,
                                      width: 6,
                                      height: 6,
                                      borderRadius: "50%",
                                      backgroundColor: "#4CAF50",
                                    }}
                                  />
                                )}
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: isActive ? "#888" : "#aaa",
                                  }}
                                >
                                  {date.format("DD MMM YYYY")}
                                </Typography>
                                {displayCount > 0 ? (
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      color: isActive ? "#FFC107" : "#888",
                                      mt: "2px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    ₹
                                    {Number(
                                      displayMinRate
                                    ).toLocaleString("en-IN")}
                                    <Box
                                      component="span"
                                      sx={{
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        color: isActive
                                          ? "#FFD54F"
                                          : "#AAA",
                                      }}
                                    >
                                      Onwards
                                    </Box>
                                  </Typography>
                                ) : isStillLoading ? (
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      color: "#aaa",
                                      mt: "2px",
                                    }}
                                  >
                                    Loading...
                                  </Typography>
                                ) : (
                                  <Typography
                                    sx={{
                                      fontSize: "11px",
                                      color: "error.main",
                                      fontStyle: "italic",
                                      mt: "2px",
                                    }}
                                  >
                                    No results
                                  </Typography>
                                )}
                              </Box>
                            }
                          />
                        );
                      })}
                      {isStillLoading && !activeFilters?.filtersset && (
                        <Tab
                          disabled
                          value={-1}
                          label={<SkeletonTabs />}
                        />
                      )}
                    </Tabs>
                  </Box>

                  {hasMore === false &&
                    (hasAnyData || activeFilters?.filtersset) && (
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        sx={{ flexShrink: 0 }}
                      >
                        <FilterChips
                          data={activeFilters}
                          visibleCount={1}
                        />
                        {/* <FilterButton /> */}
                      </Stack>
                    )}
                </Box>
              </Typography>
              <div className="boxMainListingSearchRates">
              {/* <Typography sx={{ overflowX: "auto", display: "block" }}> */}
              <Typography sx={{ display: "block" }}>
                <Box
                className="boxRightDataInner"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    border: "1px solid #f0ede8",
                    padding: "12px 12px",
                    // minWidth: "900px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0,
                    }}
                    className="listingbookked"
                  >
                    {isStillLoading &&
                      !hasAnyData &&
                      !activeFilters?.filtersset && (
                        <SkeletonCards count={6} />
                      )}

                    {currentTabItems.length === 0 &&
                      hasAnyData &&
                      activeFilters?.filtersset &&
                      ((!isStillLoading) ||
                        (activeFilters?.category &&
                          !activeFilters?.services?.length)) && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            py: 8,
                            gap: 1,
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "text.secondary",
                            }}
                          >
                            No rates available
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                          >
                            No results match your current filters. Try
                            adjusting or resetting them.
                          </Typography>
                        </Box>
                      )}

                    {currentTabItems.length > 0 && (
                      <Box
                        className="tableHeadingSearchRates"
                        sx={{
                          display: "grid",
                          gridTemplateColumns:
                            "40px 120px 1fr 145px 135px 80px 110px 90px 190px 160px",
                          gap: 1,
                          padding: "6px 20px 6px 24px",
                          mb: "4px",
                        }}
                      >
                        <Box />
                        {[
                          "Carrier",
                          "Itinerary",
                          "Departure",
                          "Arrival",
                          "Duration",
                          "Service",
                          "Freight/kg",
                          "Surcharges",
                        ].map((col) => (
                          <Typography
                            key={col}
                            sx={{
                              fontSize: "11px",
                              fontWeight: 700,
                              color: "#a8a29e",
                              textTransform: "uppercase",
                              letterSpacing: "0.8px",
                              width: "100%",
                              ...(col === "Surcharges"
                                ? { textAlign: "left", justifySelf: "start" }
                                : { textAlign: "center", justifySelf: "center" }),
                            }}
                          >
                            {col}
                          </Typography>
                        ))}
                      </Box>
                    )}

                    {sortedTabItems?.map((option, index) => {
                      const _item = option?.flightItineraries?.[0];
                      const scheduledArrivalTime =
                        option?.flightItineraries?.[
                          option?.flightItineraries?.length - 1
                        ]?.scheduledArrivalTime;
                      const isRowExpanded = expandedRows?.includes(index);
                      const checkAirline =
                        option?.flightItineraries?.[0]?.carrierCode ===
                        "020";
                      const airline = option?.carrierName;
                      const surchargeBreakdown =
                        option?.rateDetails?.chargesBreakDown?.filter(
                          (item) => item?.chargeType === "Surcharge"
                        );
                      const tbzor = airportMap[option?.origin];
                      const tbzdes = airportMap[option?.destination];
                      const serviceType = option?.productDescription;
                      const numStops =
                        (option?.flightItineraries?.length ?? 1) - 1;
                      const stopViaAirports = option?.flightItineraries
                        ?.slice(0, -1)
                        ?.map((f) => f?.segmentOfArrival)
                        .join(", ");
                      const rateType =
                        option?.ratesFrom === "storedrate" &&
                          surchargeBreakdown?.length > 0
                          ? "ALL IN"
                          : "FFS";
                      const rateDisplay = computeDisplayRate(
                        option,
                        surchargeSelection
                      );

                      return (
                        <Box
                          key={
                            sortAnimKey !== null
                              ? `${sortAnimKey}-${index}`
                              : index
                          }
                          className="boxListingSearchRates"
                          sx={{
                            mb: "3px",
                            ...(sortAnimKey !== null && {
                              animation:
                                "sortCardIn 0.5s cubic-bezier(0.22, 1, 0.36, 1) both",
                              animationDelay: `${Math.min(
                                index * 0.06,
                                0.6
                              )}s`,
                            }),
                          }}
                        >
                          <Paper
                            sx={{
                              backgroundColor: isRowExpanded
                                ? "#FFFDF5"
                                : "#fff",
                              borderRadius: "10px",
                              overflow: "hidden",
                              boxShadow: isRowExpanded
                                ? "0 2px 10px rgba(255,193,7,0.18)"
                                : "0 1px 4px rgba(0,0,0,0.07)",
                              border: isRowExpanded
                                ? "1px solid #FFE082"
                                : "1px solid #f0ede8",
                              borderLeft: "4px solid #FFC107",
                              transition:
                                "box-shadow 0.2s, background-color 0.2s",
                            }}
                          >
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns:
                                  "40px 120px 1fr 145px 135px 80px 110px 90px 190px 160px",
                                gap: 1,
                                alignItems: "center",
                                justifyItems: "center",
                                textAlign: "center",
                                padding: "5px 16px",
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor:
                                    "rgba(255,248,225,0.5)",
                                },
                                transition: "background-color 0.15s",
                              }}
                              onClick={() => toggleRow(index)}
                            >
                              <IconButton
                                size="small"
                                sx={{ padding: "4px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleRow(index);
                                }}
                              >
                                {isRowExpanded ? (
                                  <KeyboardArrowUp fontSize="small" />
                                ) : (
                                  <KeyboardArrowDown fontSize="small" />
                                )}
                              </IconButton>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "2px",
                                }}
                              >
                                <img
                                  src={option?.carrierLogo || airlinelogo}
                                  style={{
                                    width: 50,
                                    height: 50,
                                    objectFit: "contain",
                                  }}
                                  alt=""
                                />
                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 600,
                                    color: "#333",
                                    textAlign: "center",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  {airline}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                  width: "100%",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 700,
                                      color: "#555",
                                    }}
                                  >
                                    {option?.origin}
                                  </Typography>
                                  <FlightIcon
                                    sx={{
                                      color: "#888",
                                      fontSize: "14px",
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 700,
                                      color: "#555",
                                    }}
                                  >
                                    {option?.destination}
                                  </Typography>
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "#999",
                                    textAlign: "center",
                                  }}
                                >
                                  {numStops === 0
                                    ? "Direct"
                                    : `${numStops} stop${numStops > 1 ? "s" : ""
                                    } via ${stopViaAirports}`}
                                </Typography>
                              </Box>

                              <Tooltip
                                title={
                                  _item?.scheduledDepartureTime
                                    ? `UTC: ${moment
                                      .tz(
                                        _item.scheduledDepartureTime,
                                        tbzor?.tz_db_timezone ||
                                        "Asia/Kolkata"
                                      )
                                      .utc()
                                      .format("DD/MM/YYYY HH:mm")}`
                                    : ""
                                }
                                arrow
                                placement="top"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1a1a1a",
                                    cursor: "pointer",
                                    whiteSpace: "nowrap",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {moment(
                                    _item?.scheduledDepartureTime
                                  ).format("DD/MM/YYYY HH:mm")}
                                </Typography>
                              </Tooltip>

                              <Tooltip
                                title={
                                  scheduledArrivalTime
                                    ? `UTC: ${moment
                                      .tz(
                                        scheduledArrivalTime,
                                        tbzdes?.tz_db_timezone ||
                                        "Asia/Kolkata"
                                      )
                                      .utc()
                                      .format("DD/MM/YYYY HH:mm")}`
                                    : ""
                                }
                                arrow
                                placement="top"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 500,
                                    color: "#1a1a1a",
                                    cursor: "pointer",
                                    whiteSpace: "nowrap",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {moment(scheduledArrivalTime).format(
                                    "DD/MM/YYYY HH:mm"
                                  )}
                                </Typography>
                              </Tooltip>

                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 700,
                                  color: "#EFA603",
                                }}
                              >
                                {convertMinutesToHoursAndMinutes(
                                  option?.travelTime
                                )}
                              </Typography>

                              <Box
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "2px 6px",
                                  borderRadius: "12px",
                                  backgroundColor: "#FFF3CD",
                                  border: "1px solid #FFC107",
                                  maxWidth: "100px",
                                  overflow: "hidden",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "#856404",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={serviceType}
                                >
                                  {serviceType || "Standard"}
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {rateDisplay.airFreightRatePerkilo !=
                                  null ? (
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      color: "#333",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    ₹
                                    {Number(
                                      rateDisplay.airFreightRatePerkilo
                                    ).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}{" "}
                                    /kg
                                  </Typography>
                                ) : (
                                  <Typography
                                    sx={{ fontSize: "12px", color: "#999" }}
                                  >
                                    -
                                  </Typography>
                                )}
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "flex-start",
                                  justifyContent: "start",
                                  justifySelf: "start",
                                  width: "100%",
                                  gap: "4px",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    gap: "2px",
                                    minWidth: 0,
                                  }}
                                >
                                  {rateDisplay.chargeLines?.length ? (
                                    rateDisplay.chargeLines.map((line) => (
                                      <Typography
                                        key={line.key}
                                        sx={{
                                          fontSize: "10px",
                                          color: "#555",
                                          fontWeight: 500,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {line.label} :{" "}
                                        <Box
                                          component="span"
                                          sx={{
                                            fontWeight: 600,
                                            color: "#333",
                                          }}
                                        >
                                          {formatrates(
                                            Number(line.amount ?? 0).toFixed(2)
                                          )}
                                        </Box>
                                      </Typography>
                                    ))
                                  ) : (
                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        color: "#999",
                                        fontWeight: 500,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      -
                                    </Typography>
                                  )}
                                </Box>
                                {rateDisplay.showInfoIcon && (
                                  <InfoOutlinedIcon
                                    sx={{
                                      fontSize: 16,
                                      color: "#EFA603",
                                      cursor: "pointer",
                                      flexShrink: 0,
                                      mt: "-1px",
                                    }}
                                    onMouseEnter={(e) => {
                                      clearTimeout(_cpCloseTimer);
                                      const realBreakdown =
                                        option?.rateDetails?.chargesBreakDown;
                                      // "ALL IN" rates have no real break-down —
                                      // synthesise one from the computed lines so
                                      // the popover isn't empty.
                                      const popoverBreakdown =
                                        realBreakdown?.length
                                          ? realBreakdown
                                          : (rateDisplay.chargeLines || []).map(
                                            (l) => ({
                                              chargeType: l.label,
                                              chargeDescription: l.label,
                                              chargeAmount: l.amount,
                                            })
                                          );
                                      setChargePopover({
                                        anchor: e.currentTarget,
                                        breakdown: popoverBreakdown,
                                      });
                                    }}
                                    onMouseLeave={() => {
                                      _cpCloseTimer = setTimeout(
                                        () =>
                                          setChargePopover({
                                            anchor: null,
                                            breakdown: [],
                                          }),
                                        10
                                      );
                                    }}
                                  />
                                )}
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                  alignSelf: "stretch",
                                  backgroundColor: "#FFFDE7",
                                  border: "1px solid #FFE082",
                                  margin: "8px 8px 8px 0",
                                  padding: "10px 12px",
                                  minWidth: "160px",
                                  borderRadius: "8px",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {(() => {
                                  const { total, perKg } = getDisplayTotals(option, surchargeSelection);
                                  return (
                                    <>
                                      <Typography sx={{ fontSize: "17px", fontWeight: 500, color: "#0b0b0b", whiteSpace: "nowrap", lineHeight: 1.2 }}>
                                        {formatrates(Number(total ?? 0).toFixed(2))}
                                      </Typography>
                                      {perKg != null && (
                                        <Typography sx={{ fontSize: "11px", color: "#888", whiteSpace: "nowrap", lineHeight: 1 }}>
                                          ₹{Number(perKg).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} /kg
                                        </Typography>
                                      )}
                                    </>
                                  );
                                })()}

                                {props?.nodeData?.isAllreadyBooked !== undefined && props?.nodeData?.isAllreadyBooked ? (
                                  <Button variant="contained" disabled sx={{ fontSize: "12px", fontWeight: 700, py: "6px", width: "calc(100% - 2px)", "&.Mui-disabled": { bgcolor: "grey.300", color: "text.primary" } }}>
                                    Already Booked
                                  </Button>
                                ) : props?.nodeData?.isExpired !== undefined && props?.nodeData?.isExpired ? (
                                  <Button variant="contained" disabled sx={{ fontSize: "12px", fontWeight: 700, py: "6px", width: "calc(100% - 2px)", "&.Mui-disabled": { bgcolor: "grey.300", color: "text.primary" } }}>
                                    Quote Expired
                                  </Button>
                                ) : (
                                  // ✅ Tooltip only shown when booking is blocked due to KYC
                                  <Tooltip
                                    title={
                                      !kycAccepted
                                        ? "Booking is unavailable until your KYC verification is completed."
                                        : checkForKam_user()
                                          ? "You do not have permission to book."
                                          : ""
                                    }
                                    arrow
                                    placement="top"
                                    disableHoverListener={kycAccepted && !checkForKam_user()}
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#FEF3E2",
                                          color: "#7A4100",
                                          border: "1px solid #F5A623",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          borderRadius: "6px",
                                          padding: "6px 12px",
                                          maxWidth: 220,
                                          boxShadow: "0 2px 8px rgba(239,166,3,0.18)",
                                        },
                                      },
                                      arrow: {
                                        sx: { color: "#F5A623" },
                                      },
                                    }}
                                  >
                                    {/* span wrapper required — MUI Tooltip does not attach to disabled buttons */}
                                    <span style={{ width: "calc(100% - 2px)", display: "block" }}>
                                      <Button
                                        variant="contained"
                                        fullWidth
                                        disabled={checkForKam_user() || !kycAccepted || isQuoteExpired}
                                        sx={{
                                          fontSize: "12px",
                                          fontWeight: 400,
                                          color: "#000000",
                                          letterSpacing: "1px",
                                          textTransform: "uppercase",
                                          py: "6px",
                                          width: "100%",
                                          backgroundColor: "#ffc107",
                                          "&:hover": { backgroundColor: "#d4940a", color: "#000000" },
                                          ...((checkForKam_user() || !kycAccepted || isQuoteExpired) && {
                                            "&.Mui-disabled": { bgcolor: "grey.300", color: "rgba(15,15,15,0.39)" },
                                          }),
                                        }}
                                        onClick={() => handleCheckBooking(option, checkAirline)}
                                      >
                                        Book Now
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}
                              </Box>
                            </Box>

                            <Collapse
                              in={isRowExpanded}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box
                                sx={{
                                  backgroundColor: "#FFFDF5",
                                  borderTop: "1px solid #FFE082",
                                  padding: "16px 24px",
                                }}
                              >
                                {option?.flightItineraries?.length > 1 && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      mb: 3,
                                      px: 1,
                                      width: "100%",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        height: 20,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 14,
                                          height: 14,
                                          borderRadius: "50%",
                                          backgroundColor: "#FFC107",
                                          border: "2.5px solid #EFA603",
                                          flexShrink: 0,
                                          zIndex: 2,
                                        }}
                                      />
                                      {option.flightItineraries.map(
                                        (flight, fIdx) => {
                                          const isLastFlight =
                                            fIdx ===
                                            option.flightItineraries.length -
                                            1;
                                          return (
                                            <React.Fragment key={fIdx}>
                                              <Box
                                                sx={{
                                                  flex: 1,
                                                  height: 5,
                                                  backgroundColor: "#FFC107",
                                                  borderRadius: 3,
                                                  mx: "2px",
                                                }}
                                              />
                                              {!isLastFlight ? (
                                                <Box
                                                  sx={{
                                                    width: 16,
                                                    height: 16,
                                                    borderRadius: "50%",
                                                    backgroundColor: "#FFF",
                                                    border:
                                                      "2.5px solid #FFC107",
                                                    flexShrink: 0,
                                                    zIndex: 2,
                                                  }}
                                                />
                                              ) : (
                                                <Box
                                                  sx={{
                                                    width: 14,
                                                    height: 14,
                                                    borderRadius: "50%",
                                                    backgroundColor: "#FFC107",
                                                    border:
                                                      "2.5px solid #EFA603",
                                                    flexShrink: 0,
                                                    zIndex: 2,
                                                  }}
                                                />
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        width: "100%",
                                        mt: "5px",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          flexShrink: 0,
                                          minWidth: 32,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontSize: "11px",
                                            fontWeight: 700,
                                            color: "#333",
                                          }}
                                        >
                                          {
                                            option.flightItineraries[0]
                                              ?.segmentOfDeparture
                                          }
                                        </Typography>
                                      </Box>
                                      {option.flightItineraries.map(
                                        (flight, fIdx) => {
                                          const isLastFlight =
                                            fIdx ===
                                            option.flightItineraries.length -
                                            1;
                                          const nextFlight =
                                            option.flightItineraries[fIdx + 1];
                                          return (
                                            <React.Fragment key={fIdx}>
                                              <Box
                                                sx={{
                                                  flex: 1,
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: "10px",
                                                    color: "#FFC107",
                                                    fontWeight: 600,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "3px",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <span
                                                    style={{ fontSize: "11px" }}
                                                  >
                                                    ✈
                                                  </span>{" "}
                                                  {flight?.travelTime
                                                    ? flight.travelTime
                                                    : ""}
                                                </Typography>
                                              </Box>
                                              {!isLastFlight ? (
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    flexShrink: 0,
                                                    minWidth: 32,
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: "11px",
                                                      fontWeight: 700,
                                                      color: "#FFC107",
                                                      lineHeight: 1.2,
                                                    }}
                                                  >
                                                    {flight?.segmentOfArrival}
                                                  </Typography>
                                                  <Typography
                                                    sx={{
                                                      fontSize: "9px",
                                                      fontWeight: 400,
                                                      color: "#aaa",
                                                      lineHeight: 1.2,
                                                      mt: "2px",
                                                    }}
                                                  >
                                                    {nextFlight?.layoverTime}
                                                  </Typography>
                                                </Box>
                                              ) : (
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    flexShrink: 0,
                                                    minWidth: 32,
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: "11px",
                                                      fontWeight: 700,
                                                      color: "#333",
                                                    }}
                                                  >
                                                    {flight?.segmentOfArrival}
                                                  </Typography>
                                                </Box>
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </Box>
                                  </Box>
                                )}

                                <TableContainer
                                  sx={{
                                    border: "1px solid #E5E5E5",
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          backgroundColor: "#FAFAFA",
                                          borderBottom: "1px solid #ECECEC",
                                        }}
                                      >
                                        {[
                                          "Carrier",
                                          "Route",
                                          "Departure",
                                          "Arrival",
                                          "Duration",
                                          "Aircraft",
                                          "Flight #",
                                        ].map((h) => (
                                          <TableCell
                                            key={h}
                                            sx={{
                                              py: 2,
                                              borderBottom: "none",
                                              fontSize: "12px",
                                              fontWeight: 500,
                                              color: "#9A9A9A",
                                              textTransform: "uppercase",
                                              letterSpacing: "0.4px",
                                            }}
                                          >
                                            {h}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {option?.flightItineraries?.map(
                                        (detail, idx) => {
                                          const depTZ =
                                            airportMap[
                                            detail?.segmentOfDeparture
                                            ];
                                          const arrTZ =
                                            airportMap[
                                            detail?.segmentOfArrival
                                            ];
                                          return (
                                            <React.Fragment key={idx}>
                                              {idx > 0 &&
                                                detail?.layoverTime && (
                                                  <TableRow>
                                                    <TableCell
                                                      colSpan={7}
                                                      sx={{
                                                        backgroundColor:
                                                          "#FFF7E2",
                                                        borderBottom:
                                                          "1px solid #F3E2B3",
                                                        py: 1.5,
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                          gap: "8px",
                                                        }}
                                                      >
                                                        <AccessTimeIcon
                                                          sx={{
                                                            fontSize: "18px",
                                                            color: "#A87400",
                                                          }}
                                                        />
                                                        <Typography
                                                          sx={{
                                                            fontSize: "14px",
                                                            color: "#8A6500",
                                                            fontWeight: 500,
                                                          }}
                                                        >
                                                          {`Layover at ${detail.segmentOfDeparture} — ${detail.layoverTime}`}
                                                        </Typography>
                                                      </Box>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              <TableRow
                                                sx={{
                                                  "&:hover": {
                                                    backgroundColor: "#FCFCFC",
                                                  },
                                                  "& td": {
                                                    borderBottom:
                                                      "1px solid #F1F1F1",
                                                    py: 2.2,
                                                  },
                                                }}
                                              >
                                                <TableCell>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 1.5,
                                                    }}
                                                  >
                                                    <Box
                                                      sx={{
                                                        width: 38,
                                                        height: 38,
                                                        borderRadius: "8px",
                                                        border:
                                                          "1px solid #EEE",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        backgroundColor: "#fff",
                                                      }}
                                                    >
                                                      <img
                                                        src={
                                                          detail?.carrierLogo ||
                                                          airlinelogo
                                                        }
                                                        alt=""
                                                        style={{
                                                          width: 35,
                                                          height: 35,
                                                          objectFit: "contain",
                                                        }}
                                                      />
                                                    </Box>
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        color: "#111",
                                                      }}
                                                    >
                                                      {detail?.carrierName}
                                                    </Typography>
                                                  </Box>
                                                </TableCell>
                                                <TableCell>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        color: "#222",
                                                      }}
                                                    >
                                                      {
                                                        detail?.segmentOfDeparture
                                                      }
                                                    </Typography>
                                                    <FlightIcon
                                                      sx={{
                                                        fontSize: "18px",
                                                        color: "#F4B400",
                                                        transform:
                                                          "rotate(90deg)",
                                                      }}
                                                    />
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        color: "#222",
                                                      }}
                                                    >
                                                      {detail?.segmentOfArrival}
                                                    </Typography>
                                                  </Box>
                                                </TableCell>
                                                <TableCell>
                                                  <Tooltip
                                                    title={
                                                      detail?.scheduledDepartureTime
                                                        ? `UTC: ${moment
                                                          .tz(
                                                            detail.scheduledDepartureTime,
                                                            depTZ?.tz_db_timezone ||
                                                            "Asia/Kolkata"
                                                          )
                                                          .utc()
                                                          .format(
                                                            "DD/MM/YYYY HH:mm"
                                                          )}`
                                                        : ""
                                                    }
                                                    arrow
                                                    placement="top"
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        color: "#111",
                                                        fontWeight: 500,
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      {moment(
                                                        detail?.scheduledDepartureTime
                                                      ).format(
                                                        "DD/MM/YYYY HH:mm"
                                                      )}
                                                    </Typography>
                                                  </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                  <Tooltip
                                                    title={
                                                      detail?.scheduledArrivalTime
                                                        ? `UTC: ${moment
                                                          .tz(
                                                            detail.scheduledArrivalTime,
                                                            arrTZ?.tz_db_timezone ||
                                                            "Asia/Kolkata"
                                                          )
                                                          .utc()
                                                          .format(
                                                            "DD/MM/YYYY HH:mm"
                                                          )}`
                                                        : ""
                                                    }
                                                    arrow
                                                    placement="top"
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        color: "#111",
                                                        fontWeight: 500,
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      {moment(
                                                        detail?.scheduledArrivalTime
                                                      ).format(
                                                        "DD/MM/YYYY HH:mm"
                                                      )}
                                                    </Typography>
                                                  </Tooltip>
                                                </TableCell>
                                                <TableCell>
                                                  <Typography
                                                    sx={{
                                                      fontSize: "14px",
                                                      color: "#111",
                                                      fontWeight: 500,
                                                    }}
                                                  >
                                                    {detail?.travelTime || "-"}
                                                  </Typography>
                                                </TableCell>
                                                <TableCell>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                  >
                                                    <FlightIcon
                                                      sx={{
                                                        fontSize: "18px",
                                                        color: "#F4B400",
                                                        transform:
                                                          "rotate(90deg)",
                                                      }}
                                                    />
                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        color: "#222",
                                                      }}
                                                    >
                                                      {
                                                        detail?.carrierAircraftType
                                                      }
                                                    </Typography>
                                                  </Box>
                                                </TableCell>
                                                <TableCell>
                                                  <Typography
                                                    sx={{
                                                      fontSize: "14px",
                                                      fontWeight: 500,
                                                      color: "#111",
                                                    }}
                                                  >
                                                    {/* Manual-quote rows may carry a
                                                        separate carrierCode — prepend it
                                                        to the flight number when present
                                                        (unless it's already included),
                                                        else show the flight number alone. */}
                                                    {(option?.flightItineraries?.[0]
                                                      ?.rates_from ||
                                                      option?.ratesFrom) ===
                                                    "manualQoute" ? (
                                                      formatFlightNo(
                                                        "manualQoute",
                                                        detail?.carrierCode,
                                                        detail?.carrierNumber
                                                      )
                                                    ) : (
                                                      <>
                                                        {detail?.carrierCode}{" "}
                                                        {detail?.carrierNumber}
                                                      </>
                                                    )}
                                                  </Typography>
                                                </TableCell>
                                              </TableRow>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Box>
                            </Collapse>
                          </Paper>
                        </Box>
                      );
                    })}

                    <Popover
                      open={Boolean(chargePopover.anchor)}
                      anchorEl={chargePopover.anchor}
                      onClose={() =>
                        setChargePopover({ anchor: null, breakdown: [] })
                      }
                      anchorOrigin={{
                        vertical: "center",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "center",
                        horizontal: "right",
                      }}
                      disableRestoreFocus
                      sx={{ pointerEvents: "none" }}
                      PaperProps={{
                        sx: {
                          borderRadius: "12px",
                          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                          overflow: "hidden",
                          pointerEvents: "auto",
                        },
                        onMouseEnter: () => clearTimeout(_cpCloseTimer),
                        onMouseLeave: () => {
                          _cpCloseTimer = setTimeout(
                            () =>
                              setChargePopover({
                                anchor: null,
                                breakdown: [],
                              }),
                            180
                          );
                        },
                      }}
                    >
                      <ChargeBreakdownContent
                        breakdown={chargePopover.breakdown}
                        surchargeSelection={surchargeSelection}
                      />
                    </Popover>

                    {hasAnyData &&
                      isStillLoading &&
                      !activeFilters?.filtersset && (
                        <SkeletonCards count={4} />
                      )}
                  </Box>
                </Box>
              </Typography>
              </div>
            </Box>
          </div>
        </div>
      </Box>

      {/* ─── Booking Dialog ─── */}
      <AlertDialogBox
        open={open}
        type="cancelBooking"
        handleBack={() => navigate(-1)}
        handleClose={() => setOpen(0)}
      >
        <Box sx={{ padding: 2, width: "full" }}>
          <Typography variant="h5" sx={{ fontWeight: 600, padding: 1 }}>
            Book Shipment
          </Typography>
          <Paper
            sx={{
              padding: 2,
              mb: 2,
              backgroundColor: "#fff9eb",
              borderRadius: 2,
              border: "1px solid #f9e8c0",
              boxShadow: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#f4be3d" }}
                >
                  {airportcode?.origincode},{" "}
                  {
                    (originAirport || originPort)
                      ?.origincountryName
                  }{" → "}
                  {airportcode?.destinationcode},{" "}
                  {
                    (destinationAirport || destinationPort)
                      ?.destinationcountryName
                  }
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: 14,
                    marginTop: 0.5,
                  }}
                >
                  Departure Date: {goodsDetails?.cargoreadydate} | Goods
                  type: {productDetails?.natureOfGoods} | Total shipment:{" "}
                  {packagingDetails?.shipmentTotal?.totalunits} Units,{" "}
                  {Number(
                    packagingDetails?.shipmentTotal?.totalvolume
                  )?.toFixed(4)}{" "}
                  {packagingDetails?.shipmentTotal?.unit},{" "}
                  {packagingDetails?.shipmentTotal?.totalweight}
                  {packagingDetails?.shipmentTotal?.weightunit}
                </Typography>
              </Box>
            </Box>
          </Paper>

          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 4 }}
          >
            {availabilityResponseSOs?.[
              indexTab
            ]?.availabilityResponseSOs
              ?.filter(
                (option) => getRateKey(option) === getRateKey(selecteddata)
              )
              ?.map((option, index) => {
                const _item = option?.flightItineraries?.[0];
                const scheduledArrivalTime =
                  option?.flightItineraries?.[
                    option?.flightItineraries?.length - 1
                  ]?.scheduledArrivalTime;
                const uniqueKey = getRateKey(option);
                const isRowExpanded2 = expandedRows2.includes(uniqueKey);
                const airline = option?.carrierName;
                const tbzor = airportMap[option?.origin];
                const tbzdes = airportMap[option?.destination];
                const serviceType = option?.productDescription;
                return (
                  <Paper
                    key={index}
                    sx={{
                      backgroundColor: "#fff9eb",
                      borderRadius: 2,
                      border: "1px solid #f9e8c0",
                      overflow: "hidden",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        p: 2,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mr: 3,
                          minWidth: 100,
                        }}
                      >
                        <img
                          src={option?.carrierLogo || airlinelogo}
                          alt={airline}
                          style={{
                            width: 90,
                            height: 90,
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: "text.primary",
                            fontSize: "0.8rem",
                          }}
                        >
                          {airline}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <FlightIcon
                          sx={{
                            color: "primary.main",
                            transform: "rotate(90deg)",
                            mr: 1,
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 400,
                            color: "text.primary",
                          }}
                        >
                          {option?.origin} - {option?.destination}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 500,
                          color: "#4A4A4A",
                        }}
                      >
                        <div className="timemain listingCommon">
                          <Tooltip
                            title={
                              _item?.scheduledDepartureTime
                                ? `UTC: ${moment
                                  .tz(
                                    _item.scheduledDepartureTime,
                                    tbzor?.tz_db_timezone ||
                                    "Asia/Kolkata"
                                  )
                                  .utc()
                                  .format("DD/MM/YYYY HH:mm")}`
                                : ""
                            }
                            arrow
                            placement="top"
                          >
                            <div
                              className="timestart timescommon"
                              style={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  fontSize: "1rem",
                                  fontWeight: 400,
                                }}
                              >
                                {moment(
                                  _item?.scheduledDepartureTime
                                ).format("DD MMM YYYY")}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "0.8rem",
                                  fontWeight: 400,
                                }}
                              >
                                {moment(
                                  _item?.scheduledDepartureTime
                                ).format("hh:mm A")}
                              </Typography>
                            </div>
                          </Tooltip>
                          <div className="timeTotal">
                            <strong>
                              {" "}
                              -{" "}
                              {convertMinutesToHoursAndMinutes(
                                option?.travelTime
                              )}{" "}
                              -{" "}
                            </strong>
                          </div>
                          <Tooltip
                            title={
                              scheduledArrivalTime
                                ? `UTC: ${moment
                                  .tz(
                                    scheduledArrivalTime,
                                    tbzdes?.tz_db_timezone ||
                                    "Asia/Kolkata"
                                  )
                                  .utc()
                                  .format("DD/MM/YYYY HH:mm")}`
                                : ""
                            }
                            arrow
                            placement="top"
                          >
                            <div
                              className="timeend timescommon"
                              style={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  fontSize: "1rem",
                                  fontWeight: 400,
                                }}
                              >
                                {moment(scheduledArrivalTime).format(
                                  "DD MMM YYYY"
                                )}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "1rem",
                                  fontWeight: 400,
                                }}
                              >
                                {moment(scheduledArrivalTime).format(
                                  "hh:mm A"
                                )}
                              </Typography>
                            </div>
                          </Tooltip>
                        </div>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, fontSize: "1rem" }}
                        >
                          {formatrates(option?.rateDetails?.totalAmount)}
                        </Typography>
                      </Box>
                    </Box>
                    <hr className="border-gray-300 border-3 my-3" />
                    <Box
                      sx={{ flex: 1, margin: 0, minWidth: 0 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            marginLeft: 1,
                            fontSize: "0.8rem",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={aeroplan}
                            className="w-2 h-2 p-1 bg-yellow-300 rounded-full"
                            alt="Service Type"
                          />
                          <span className="ml-2">
                            Service: {serviceType}
                          </span>
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => toggleRow2(uniqueKey)}
                          sx={{ ml: "auto", marginRight: 1 }}
                        >
                          {isRowExpanded2 ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </Box>
                    </Box>
                    <Collapse
                      in={isRowExpanded2}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box
                        sx={{
                          p: 2,
                          backgroundColor: "white",
                          borderTop: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {option?.flightItineraries?.map(
                            (detail, idx) => {
                              const depTZ = airports?.find(
                                (item) =>
                                  item?.code ===
                                  detail?.segmentOfDeparture
                              );
                              const arrTZ = airports?.find(
                                (item) =>
                                  item?.code ===
                                  detail?.segmentOfArrival
                              );
                              return (
                                <Box key={idx}>
                                  <Paper>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                        flexDirection: "row",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          minWidth: 180,
                                        }}
                                      >
                                        <img
                                          src={
                                            detail?.carrierLogo ||
                                            airlinelogo
                                          }
                                          width={90}
                                          height={90}
                                          alt="Airline"
                                        />
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: "bold",
                                            fontSize: "0.6rem",
                                          }}
                                        >
                                          {detail?.carrierName}
                                        </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          flexDirection: "column",
                                          gap: 1,
                                        }}
                                      >
                                        <FlightIcon
                                          sx={{
                                            color: "primary.main",
                                            transform: "rotate(90deg)",
                                            mx: 1,
                                          }}
                                        />
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: "semi-bold",
                                            fontSize: "0.6rem",
                                          }}
                                        >
                                          {detail?.segmentOfDeparture}{" "}
                                          to {detail?.segmentOfArrival}
                                        </Typography>
                                      </Box>
                                      <div className="timemain listingCommon">
                                        <Tooltip
                                          title={
                                            detail?.scheduledDepartureTime
                                              ? `UTC: ${moment
                                                .tz(
                                                  detail.scheduledDepartureTime,
                                                  depTZ?.tz_db_timezone ||
                                                  "Asia/Kolkata"
                                                )
                                                .utc()
                                                .format(
                                                  "DD/MM/YYYY HH:mm"
                                                )}`
                                              : ""
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <div
                                            className="timestart timescommon"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{
                                                fontSize: "1rem",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {moment(
                                                detail?.scheduledDepartureTime
                                              ).format("DD MMM YYYY")}
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "1rem",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {moment(
                                                detail?.scheduledDepartureTime
                                              ).format("hh:mm A")}
                                            </Typography>
                                          </div>
                                        </Tooltip>
                                        <div className="timeTotal">
                                          <strong>
                                            -{detail?.travelTime}-
                                          </strong>
                                        </div>
                                        <Tooltip
                                          title={
                                            detail?.scheduledArrivalTime
                                              ? `UTC: ${moment
                                                .tz(
                                                  detail.scheduledArrivalTime,
                                                  arrTZ?.tz_db_timezone ||
                                                  "Asia/Kolkata"
                                                )
                                                .utc()
                                                .format(
                                                  "DD/MM/YYYY HH:mm"
                                                )}`
                                              : ""
                                          }
                                          arrow
                                          placement="top"
                                        >
                                          <div
                                            className="timeend timescommon"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <Typography
                                              variant="body1"
                                              sx={{
                                                fontSize: "1rem",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {moment(
                                                detail?.scheduledArrivalTime
                                              ).format("DD MMM YYYY")}
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "1rem",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {moment(
                                                detail?.scheduledArrivalTime
                                              ).format("hh:mm A")}
                                            </Typography>
                                          </div>
                                        </Tooltip>
                                      </div>
                                      <Box sx={{ minWidth: 80 }}>
                                        <Typography
                                          variant="body2"
                                          fontWeight={300}
                                        >
                                          Aircraft
                                        </Typography>
                                        <Typography variant="body2">
                                          {detail?.carrierAircraftType}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ minWidth: 80 }}>
                                        <Typography
                                          variant="body2"
                                          fontWeight={300}
                                        >
                                          Flight #
                                        </Typography>
                                        <Typography variant="body2">
                                          {formatFlightNo(
                                            option?.flightItineraries?.[0]
                                              ?.rates_from || option?.ratesFrom,
                                            detail?.carrierCode,
                                            detail?.carrierNumber
                                          )}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Paper>
                                </Box>
                              );
                            }
                          )}
                        </Box>
                      </Box>
                    </Collapse>
                  </Paper>
                );
              })}
          </Box>
        </Box>
        <Box>
          <BookCargo
            setSelecteddata={setSelecteddata}
            setOpenbooking={setOpenbooking}
            prevbookingamt={prevBookingAmount}
            selecteddata={selecteddata}
            open={open}
            setOpen1={setOpen}
            handleClose={() => setOpen(0)}
          />
        </Box>
      </AlertDialogBox>

      <AlertDialogBox
        open={openbooking && requestType === "2"}
        handleBack={() => navigate(-1)}
        handleClose={() => setOpen(0)}
      >
        <Bookingintermediatrypage
          isOpen={openbooking && requestType === "2"}
          onClose={() => navigate("/search-rates")}
          selectedItem={selecteddata}
          title="Booking Confirmation"
          onConfirm={() => navigate("/booking-history")}
        />
      </AlertDialogBox>

      {showMixedUnitsPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
              padding: "28px 32px 24px",
              maxWidth: 460,
              width: "90%",
              position: "relative",
            }}
          >
            <button
              type="button"
              onClick={() => setShowMixedUnitsPopup(false)}
              style={{
                position: "absolute",
                top: 14,
                right: 16,
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#78716c",
                fontSize: 20,
                lineHeight: 1,
                padding: 4,
              }}
            >
              ×
            </button>
            <div
              style={{
                display: "flex",
                gap: 14,
                alignItems: "flex-start",
                marginBottom: 14,
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  border: "2px solid #ffaf00",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 2,
                }}
              >
                <span
                  style={{
                    color: "#ffaf00",
                    fontWeight: 700,
                    fontSize: 17,
                    lineHeight: 1,
                  }}
                >
                  i
                </span>
              </div>
              <p
                style={{
                  margin: 0,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#292524",
                  lineHeight: 1.5,
                }}
              >
                For searches with mixed units, the total shipment is always
                shown in CBM and the rates results provided in centimeters
                (CM) per kilo (KG).
              </p>
            </div>
            <p
              style={{
                margin: "0 0 24px 50px",
                fontSize: 13.5,
                color: "#57534e",
                lineHeight: 1.6,
              }}
            >
              Even if some of the unit dimensions are inserted in inches
              (IN), we will make a calculation based on the conversion from
              inches (IN) to centimetres (CM).
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={() => setShowMixedUnitsPopup(false)}
                style={{
                  padding: "10px 28px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1a7ad4",
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      )}

      <VerifyEmailModal
        open={showVerifyModal}
        // Without verifying there are no results to show here, so leave the page.
        onClose={() => {
          setShowVerifyModal(false);
          handleback();
        }}
        onVerified={handleEmailVerified}
        defaultEmail={userDetails?.email || userDetails?.unverified_email}
        userId={userDetails?.id}
      />
    </>
  );
};

export default React.memo(Newratelisting);